const Strings = Object.freeze({
  PORTUGUESE: "Português",
  ENGLISH: "English",
  SPANISH: "Español",
  DATE_LOCALE: "en-US",
  CURRENT_VALUE_DP: "Current value: ",
  MILLISECONDS_SUFFIX: " ms",
  KILOBITS_PER_SECOND_SUFFIX: " Kbps",
  MEGABITS_PER_SECOND_SUFFIX: " Mbps",
  TENDENCY_AND: " and ",
  TS_MONITOR_LOGO_ALT: "TS Monitor logo",
  TENDENCY_GOOD_PING_LIMIT: "< 16 ms",
  TENDENCY_WARNING_PING_LIMIT: "≥ 16 ms",
  TENDENCY_WARNING_UPPER_PING_LIMIT: "< 26 ms",
  TENDENCY_BAD_PING_LIMIT: "> 26 ms",
  NETWORK_IP_PLACEHOLDER: "192.168.0.2",
  NETWORK_MASK_PLACEHOLDER: "255.255.255.0",
  NETWORK_GATEWAY_PLACEHOLDER: "192.168.0.1",
  DHCP_PLACEHOLDER: "DHCP",
  SWEEP_FIRST_BAND_PLACEHOLDER: "192.168.2",
  SWEEP_SECOND_BAND_PLACEHOLDER: "192.168.3",
  SWEEP_THIRD_BAND_PLACEHOLDER: "192.168.4",
  SWEEP_FOURTH_BAND_PLACEHOLDER: "192.168.5",
  SWEEP_FIFTH_BAND_PLACEHOLDER: "192.168.6",
  SWEEP_BEGINNING_PLACEHOLDER: "0",
  SWEEP_END_PLACEHOLDER: "255",
  PING_LIMIT_PLACEHOLDER: "200",
  PACKET_LOSS_RATE_PLACEHOLDER: "42",
  MILLISECONDS_UNIT: "ms",
  PERCENTAGE_UNIT: "%",


  //  ---------------------------- Live List ----------------------------
  CONFIG_METHOD_1: "Configuration",
  CONFIG_METHOD_2: "method",
  LOST_PACKET_PERC_1: "Lost",
  LOST_PACKET_PERC_2: "Pings (%)",
  TENDENCY: "Trend",
  AVAILABILITY: "Availability",
  STATUS: "Status",

  OFFLINE_STRING: "Offline",
  ONLINE_STRING: "Online",
  FAULT_STRING: "Fault",

  LIVE_LIST_OK_POPUP_TEXT: "EtherNet/IP device in normal operation, that is, exchanging data.",
  LIVE_LIST_FAULT_POPUP_TEXT: "EtherNet/IP device that was previously in normal operation mode (OK), but is no longer communicating on the network.",
  LIVE_LIST_ONLINE_POPUP_TEXT: "Active device on the network that does not exchange EtherNet/IP protocol data.",
  LIVE_LIST_OFFLINE_POPUP_TEXT: "Non-EtherNet/IP device that was active on the network (Online), but is no longer accessible by the monitor.",

  ETHERNET_IP: "EtherNet/IP",

  INSUFFICIENT_DATA: "Insufficient data",


  EXPORT_CSV: "Export XLSX",

  IP_POPUP_1: "A device IP cell will have a purple background if its IP is duplicated, as in the example below.",
  IP_POPUP_2: "If the device loses its IP address, it will have an orange background, as in the example below.",
  IP_POPUP_3: "In addition, by clicking the cell it is possible to remove the device, if desired.",

  CONFIG_METHOD_POPUP_1: "Determines how the device should obtain its IP settings.",

  CONFIG_METHOD_POPUP_2: "Value (0) indicates that the device should obtain its IP settings statically.",
  CONFIG_METHOD_POPUP_3: "Value (1) indicates that the device should obtain its IP settings via BOOTP.",
  CONFIG_METHOD_POPUP_4: "Value (2) indicates that the device should obtain its IP settings via DHCP.",
  CONFIG_METHOD_POPUP_5: "Values (3-15) are reserved for future use.",

  CONFIG_METHOD_POPUP_6: "If the method is DHCP, the cell will appear as in the example below.",

  MISSED_PINGS_POPUP: "Number / % of lost pings in the last 360 pings performed.",

  NETWORK_AVAILABILITY_DP: "Network availability: ",

  LIVE_LIST_CSV_HEADER: "IP,MAC,Protocol,Configuration Method,Current Ping (ms),Average Ping (ms),Lost Pings,Lost Pings (%),Availability,Status\n",
  LIVE_LIST_CSV_EXPORT_NAME: "Live List.xlsx",
  TENDENCY_POPUP_1: "The trend bar is divided into 9 parts, each representing a portion of the last 360 ping responses (at most).",
  TENDENCY_POPUP_2: "Only pings from packets that were not lost are taken into account.",
  TENDENCY_POPUP_3: "? If all pings in the section are ",
  TENDENCY_POPUP_4: " it will be painted green.",
  TENDENCY_POPUP_5: "? If any ping in the section is ",
  TENDENCY_POPUP_6: " it will be painted yellow.",
  TENDENCY_POPUP_7: "? If any ping in the section is ",
  TENDENCY_POPUP_8: " it will be painted red.",

  // ---------------------------- Inventory ----------------------------
  PRODUCT_NAME_POPUP_1: "It is a brief description of the product, represented by the product code.",
  PRODUCT_NAME_POPUP_2: "The same product code may have a variety of product names.",
  PRODUCT_NAME_POPUP_3: "The maximum number of characters for a product name is 32.",

  VENDOR_ID_POPUP_1: "'Vendor ID' values are managed by ODVA.",
  VENDOR_ID_POPUP_2: "The value zero (0) is not considered valid.",

  REVISION_POPUP_1: "The revision consists of two values: Major and Minor.",
  REVISION_POPUP_2: "Major and Minor values are typically presented as major.minor (e.g.: 3.15).",

  PRODUCT_CODE_1: "The vendor-assigned Product Code identifies a particular product within a device type.",
  PRODUCT_CODE_2: "Each vendor assigns this code to each of its products. It is typically mapped to one or more catalog/model numbers.",
  PRODUCT_CODE_3: "Products must have different codes if their configuration and/or runtime options are different.",
  PRODUCT_CODE_4: "The value zero is not valid.",

  SERIAL_NUMBER_POPUP_1: "The serial number is used together with the Vendor ID to form a unique identifier for each device on the network.",
  SERIAL_NUMBER_POPUP_2: "Each supplier / manufacturer is responsible for ensuring the uniqueness of the serial number across all its devices.",
  SERIAL_NUMBER_POPUP_3: "Zero (0) is not a valid serial number value and must not be assigned to any product or reported by any device.",
  SERIAL_NUMBER_POPUP_4: "Receiving the value zero (0) when accessing this attribute indicates that the device does not have a serial number.",

  DEVICE_TYPE_POPUP_1: "The device type value is used to identify the device profile that the product is using.",
  DEVICE_TYPE_POPUP_2: "Profiles define the minimum requirements that the device must implement, as well as common options.",
  DEVICE_TYPE_POPUP_3: "The public list of device profiles is managed by ODVA.",

  NUM_OF_DEVICES: "Number of devices found: ",

  INVENTORY_CSV_EXPORT_NAME: "Inventory.xlsx",
  INVENTORY_CSV_HEADER: "IP,MAC,Product name,Vendor ID,Revision,Product Code,Serial Number,Device type\n",

  //  ---------------------------- PORTS ----------------------------
  PRODUCT_NAME_1: "Product",
  PRODUCT_NAME_2: "name",
  PRODUCT_NAME_3: "",

  INTERFACE_TYPE_1: "Interface",
  INTERFACE_TYPE_2: "type",

  DUPLEX_MODE_1: "Duplex",
  DUPLEX_MODE_2: "mode",

  INTERFACE_SPEED_1: "Interface",
  INTERFACE_SPEED_2: "speed",

  NEGOTIATION_STATUS_1: "Negotiation",
  NEGOTIATION_STATUS_2: "status",

  HARDWARE_FAULT_1: "Local hardware",
  HARDWARE_FAULT_2: "fault",

  INTERFACE_STATUS_1: "Interface",
  INTERFACE_STATUS_2: "state",

  LINK_STATUS_1: "Link",
  LINK_STATUS_2: "status",

  INTERFACE_TYPE_POPUP_1: "Value (0) indicates that the interface type is unknown.",
  INTERFACE_TYPE_POPUP_2: "Value (1) indicates that the interface is internal to the device.",
  INTERFACE_TYPE_POPUP_3: "Value (2) indicates that the interface is twisted pair (e.g., 10Base-T, 100Base-TX, 1000Base-T, etc.).",
  INTERFACE_TYPE_POPUP_4: "Value (3) indicates that the interface is fiber optic (e.g., 100Base-FX).",
  INTERFACE_TYPE_POPUP_5: "Values (4-256) are reserved.",
  INTERFACE_TYPE_POPUP_6: "When the value is 'No response' it means the interface type could not be determined.",

  DUPLEX_MODE_POPUP_1: "Value (0) indicates that the port is in half duplex mode.",
  DUPLEX_MODE_POPUP_2: "Value (1) indicates that the port is in full duplex mode.",
  DUPLEX_MODE_POPUP_3: "If the link status is inactive or unknown, then the duplex mode is indeterminate.",

  INTERFACE_SPEED_POPUP_1: "Indicates the speed at which the interface is running.",
  INTERFACE_SPEED_POPUP_2: "Value (0) indicates that the interface speed cannot be determined.",
  INTERFACE_SPEED_POPUP_3: "The interface speed is intended to represent bandwidth; the attribute is not duplicated if the interface is in full-duplex mode.",

  NEGOTIATION_STATUS_POPUP_1: "Value (0) indicates that auto-negotiation is in progress.",
  NEGOTIATION_STATUS_POPUP_2: "Value (1) indicates that auto-negotiation and speed detection failed. Default values for speed and duplex mode are being used. These values are product-specific (10 Mbps and half duplex are recommended).",
  NEGOTIATION_STATUS_POPUP_3: "Value (2) indicates that auto-negotiation failed, but speed was detected. A default value for duplex mode was chosen. This value is product-specific (half duplex is recommended).",
  NEGOTIATION_STATUS_POPUP_4: "Value (3) indicates that speed and duplex mode were successfully negotiated.",
  NEGOTIATION_STATUS_POPUP_5: "Value (4) indicates that auto-negotiation was not attempted. Default speed and duplex mode values were forced.",

  LOCAL_HARDWARE_FAULT_POPUP_1: "Value (0) indicates that no local hardware fault was detected on this port.",
  LOCAL_HARDWARE_FAULT_POPUP_2: "Value (1) indicates that a local hardware fault was detected. This value has a product-specific meaning, but it is assumed that this type of error requires some kind of user intervention to be corrected.",

  INTERFACE_STATUS_POPUP_1: "Value (0) indicates that the interface state is unknown.",
  INTERFACE_STATUS_POPUP_2: "Value (1) indicates that the interface is enabled and ready to send and receive data.",
  INTERFACE_STATUS_POPUP_3: "Value (2) indicates that the interface is disabled.",
  INTERFACE_STATUS_POPUP_4: "Value (3) indicates that the interface is under test.",
  INTERFACE_STATUS_POPUP_5: "Values (4-256) are reserved.",
  INTERFACE_STATUS_POPUP_6: "When the value is 'No response' it means the interface state could not be determined.",

  LINK_STATUS_POPUP_1: "Indicates whether the communication interface is connected to an active network. Link status determination is implementation-specific.",
  LINK_STATUS_POPUP_2: "In some cases, the device can tell whether the link is active through hardware / driver support.",
  LINK_STATUS_POPUP_3: "In other cases, the device may only be able to tell whether the link is active by the presence of incoming packets.",

  PORTS_FILTER_LABEL: "Ports filter",
  PORTS_FILTER_POPUP_1: "Some devices show packet loss on internal ports for which there is no possible corrective action by the user and that do not provide relevant information for analyzing the network itself.",
  PORTS_FILTER_POPUP_2: "The filter removes these ports; however, ports with unusual names may also be removed and, for this reason, the filter can be turned off to allow full visualization.",

  ARE_YOU_SURE_YOU_WANT: "Are you sure you want to ",
  THE_PORTS_FILTER: " the ports filter?",

  TURN_ON: "turn on",
  TURN_OFF: "turn off",

  PORTS_FILTER_TURN_ON_FAILURE: "An error occurred while turning on the port filter.",
  PORTS_FILTER_TURN_OFF_FAILURE: "An error occurred while turning off the port filter.",

  SHOW_ONLY_ERROR_DEVICES: "Show only devices with errors",

  //  ---------------------------- NETWORK ----------------------------
  NETWORK_TOPOLOGY_1: "Network",
  NETWORK_TOPOLOGY_2: "topology",
  NETWORK_TOPOLOGY_3: "",

  NETWORK_STATUS_1: "Network",
  NETWORK_STATUS_2: "status",
  NETWORK_STATUS_3: "",

  ADDRESS_CONFLICT_DETECTION: "Address Conflict Detection",
  RING_CAPABILITY_FLAGS: "Ring Capability Flags",

  ACD_CAPABLE_1: "ACD",
  ACD_CAPABLE_2: "capable",

  ACD_STATUS_1: "ACD",
  ACD_STATUS_2: "status",

  ANNOUNCE_BASED_RING_NODE_1: "Announce-based",
  ANNOUNCE_BASED_RING_NODE_2: "Ring Node",

  BEACON_BASED_RING_NODE_1: "Beacon-based",
  BEACON_BASED_RING_NODE_2: "Ring Node",

  FLUSH_TABLE_CAPABLE_1: "Flush Table",
  FLUSH_TABLE_CAPABLE_2: "Frame Capable",

  REDUNDANT_GATEWAY_CAPABLE_1: "Redundant Gateway",
  REDUNDANT_GATEWAY_CAPABLE_2: "Capable",

  SUPERVISOR_CAPABLE_1: "Supervisor",
  SUPERVISOR_CAPABLE_2: "Capable",

  NETWORK_TOPOLOGY_POPUP_1: "Current mode of the network topology.",
  NETWORK_TOPOLOGY_POPUP_2: "Value (0) indicates that the topology is Linear.",
  NETWORK_TOPOLOGY_POPUP_3: "Value (1) indicates that the topology is Ring.",
  NETWORK_TOPOLOGY_POPUP_4: "The value 'No response' indicates that the network topology could not be determined.",

  NETWORK_STATUS_POPUP_1: "Indicates the current status of the network based on the device's view of the network.",
  NETWORK_STATUS_POPUP_2: "Value (0 - Normal) indicates that the network is operating normally, both in Ring mode and Linear mode.",
  NETWORK_STATUS_POPUP_3: "Value (1 - Ring Fault) indicates that a ring fault was detected. This value is only valid when the network topology is Ring.",
  NETWORK_STATUS_POPUP_4: "Value (2 - Unexpected Loop Detected) indicates that a loop was detected on the network. This value is only valid when the network topology is Linear.",
  NETWORK_STATUS_POPUP_5: "Value (3 - Partial Network Fault) indicates that a network fault was detected in only one direction. This value is only valid when the network topology is Ring and the reporting node is the active ring supervisor.",
  NETWORK_STATUS_POPUP_6: "Value (4 - Rapid Fault/Restore Cycle) indicates that a series of rapid ring fault/restore cycles was detected. This value is only valid for the DLR Supervisor.",
  NETWORK_STATUS_POPUP_7: "The value 'No response' indicates that the current network status could not be determined.",

  ACD_CAPABLE_POPUP_1: "The value 'Yes' indicates that the device is capable of detecting address conflicts.",
  ACD_CAPABLE_POPUP_2: "The value 'No' indicates that the device is not capable of detecting address conflicts.",

  ACD_STATUS_POPUP_1: "Indicates when an IP address conflict is detected by ACD.",
  ACD_STATUS_POPUP_2: "By default, value 0 (false) must be set on device startup.",
  ACD_STATUS_POPUP_3: "If ACD is supported and enabled, the value will be set to 1 (true) whenever an address conflict is detected.",

  ANNOUNCE_BASED_RING_NODE_POPUP_1: "The value 'Yes' indicates that the device ring node implementation is based on processing Announce frames.",
  ANNOUNCE_BASED_RING_NODE_POPUP_2: "The value 'No' indicates that the implementation is not based on processing Announce frames.",
  ANNOUNCE_BASED_RING_NODE_POPUP_3: "The value 'No response' indicates that the value of this flag could not be determined.",

  BEACON_BASED_RING_NODE_POPUP_1: "The value 'Yes' indicates that the device ring node implementation is based on processing Beacon frames.",
  BEACON_BASED_RING_NODE_POPUP_2: "The value 'No' indicates that the implementation is not based on processing Beacon frames.",
  BEACON_BASED_RING_NODE_POPUP_3: "The value 'No response' indicates that the value of this flag could not be determined.",

  FLUSH_TABLE_CAPABLE_POPUP_1: "The value 'Yes' indicates that the device is capable of processing Flush_Table frames.",
  FLUSH_TABLE_CAPABLE_POPUP_2: "The value 'No' indicates that the device is not capable of processing Flush_Table frames.",
  FLUSH_TABLE_CAPABLE_POPUP_3: "The value 'No response' indicates that the value of this flag could not be determined.",

  REDUNDANT_GATEWAY_CAPABLE_POPUP_1: "The value 'Yes' indicates that the device is capable of providing the redundant gateway function.",
  REDUNDANT_GATEWAY_CAPABLE_POPUP_2: "The value 'No' indicates that the device is not capable of providing the redundant gateway function.",
  REDUNDANT_GATEWAY_CAPABLE_POPUP_3: "The value 'No response' indicates that the value of this flag could not be determined.",

  SUPERVISOR_CAPABLE_POPUP_1: "The value 'Yes' indicates that the device is capable of providing the supervisor function.",
  SUPERVISOR_CAPABLE_POPUP_2: "The value 'No' indicates that the device is not capable of providing the supervisor function.",
  SUPERVISOR_CAPABLE_POPUP_3: "The value 'No response' indicates that the value of this flag could not be determined.",

  //  ---------------------------- TOPOLOGY ----------------------------
  TOPOLOGY_POPUP_1: "Some devices on this screen may appear without ports. This usually occurs when:",
  TOPOLOGY_POPUP_2: "The device does not respond to SNMP queries; or",
  TOPOLOGY_POPUP_3: "SNMP is disabled on the device.",

  SNMP_POPUP_1: "This column indicates which devices respond to SNMP queries and can have two values:",
  SNMP_POPUP_2: "When the device responds to SNMP queries;",
  SNMP_POPUP_3: "When the device does not respond to SNMP queries.",

  //  ---------------------------- Media Counters ----------------------------

  ALIGNMENT_ERRORS_1: "Alignment",
  ALIGNMENT_ERRORS_2: "Errors",

  CARRIER_SENSE_ERRORS_1: "Carrier",
  CARRIER_SENSE_ERRORS_2: "Sense Errors",

  FCS_ERRORS_1: "FCS",
  FCS_ERRORS_2: "Errors",

  SINGLE_COLLISIONS_1: "Single",
  SINGLE_COLLISIONS_2: "Collisions",

  MULTIPLE_COLLISIONS_1: "Multiple",
  MULTIPLE_COLLISIONS_2: "Collisions",

  LATE_COLLISIONS_1: "Late",
  LATE_COLLISIONS_2: "Collisions",

  EXCESSIVE_COLLISIONS_1: "Excessive",
  EXCESSIVE_COLLISIONS_2: "Collisions",

  SQE_TEST_ERRORS_1: "SQE",
  SQE_TEST_ERRORS_2: "Test",
  SQE_TEST_ERRORS_3: "Errors",

  DEFERRED_TRANSMISSION_1: "Deferred",
  DEFERRED_TRANSMISSION_2: "Transmission",

  FRAME_TOO_LONG_1: "Frame",
  FRAME_TOO_LONG_2: "Too",
  FRAME_TOO_LONG_3: "Long",

  MAC_TRANSMIT_ERRORS_1: "MAC",
  MAC_TRANSMIT_ERRORS_2: "Transmit",
  MAC_TRANSMIT_ERRORS_3: "Errors",

  MAC_RECEIVE_ERRORS_1: "MAC",
  MAC_RECEIVE_ERRORS_2: "Receive",
  MAC_RECEIVE_ERRORS_3: "Errors",

  ALIGNMENT_ERRORS_POPUP: "Represents the number of received frames that do not end with an even number of octets and have some CRC problem.",

  FCS_ERRORS_POPUP_1: "Represents the number of received frames with a bad checksum (CRC value) in the Ethernet frame.",
  FCS_ERRORS_POPUP_2: "These frames are discarded and do not propagate to other ports.",

  EXCESSIVE_COLLISIONS_POPUP_1: "The excessive collisions counter is incremented after 16 consecutive Late Collisions occur in sequence.",
  EXCESSIVE_COLLISIONS_POPUP_2: "After 16 attempts to send the packet, it is discarded and the counter is incremented.",

  DEFERRED_TRANSMISSION_POPUP_1: "Total number of frames whose first transmission attempt was delayed due to network traffic.",
  DEFERRED_TRANSMISSION_POPUP_2: "This total includes only frames that are subsequently transmitted without errors and without collisions.",

  LATE_COLLISION_POPUP_1: "A late collision occurs when two devices transmit at the same time, and neither side of the connection detects the collision.",
  LATE_COLLISION_POPUP_2: "This happens because the signal propagation time from one end of the network to the other is greater than the time required to place the entire packet on the network. The two devices that cause the late collision only discover that the other is sending after the entire packet has already been placed on the network.",
  LATE_COLLISION_POPUP_3: "Late collisions are not detected by the transmitter before the first 64-byte slot. This happens because they are only detected on transmissions of packets larger than 64 bytes.",

  FRAME_TOO_LONG_POPUP: "The number of incoming packets that exceed the maximum Ethernet packet size.",

  MAC_TRANSMIT_ERRORS_POPUP: "Frames for which transmission fails due to an internal transmission error in the MAC sublayer.",
  MAC_RECEIVE_ERRORS_POPUP: "Frames for which reception on the Ethernet interface fails due to an internal receive error in the MAC sublayer.",

  IMPORTARNT_DP: "IMPORTANT: ",
  SQE_TEST_ERRORS_POPUP_1: "A test to detect collisions present in the circuit between the transceiver and the network interface card (NIC).",
  SQE_TEST_ERRORS_POPUP_2: "Because most NICs nowadays have an integrated transceiver, the SQE test is unnecessary.",
  SQE_TEST_ERRORS_POPUP_3: "Ignore this media counter.",

  CARRIER_SENSE_ERRORS_POPUP: "Number of times the carrier sense condition was lost or never asserted while attempting to transmit a frame.",

  SINGLE_COLLISION_POPUP: "Number of outgoing packets that experienced only one collision during transmission.",
  MULTIPLE_COLLISIONS_POPUP: "Number of outgoing packets that experienced more than one collision during transmission.",

  //  ---------------------------- Interface Counters ----------------------------
  INPUT: "Input",
  OUTPUT: "Output",

  IN_OCTETS_1: "In",
  IN_OCTETS_2: "Octets",

  IN_UCAST_PACKETS_1: "In",
  IN_UCAST_PACKETS_2: "Ucast Packets",

  IN_NUCAST_PACKETS_1: "In",
  IN_NUCAST_PACKETS_2: "NUcast Packets",

  IN_DISCARDS_1: "In",
  IN_DISCARDS_2: "Discards",

  IN_ERRORS_1: "In",
  IN_ERRORS_2: "Errors",

  IN_UNKNOWN_PROTOS_1: "In",
  IN_UNKNOWN_PROTOS_2: "Unknown Protos",

  OUT_OCTETS_1: "Out",
  OUT_OCTETS_2: "Octets",

  OUT_UCAST_PACKETS_1: "Out",
  OUT_UCAST_PACKETS_2: "Ucast Packets",

  OUT_NUCAST_PACKETS_1: "Out",
  OUT_NUCAST_PACKETS_2: "NUcast Packets",

  OUT_DISCARDS_1: "Out",
  OUT_DISCARDS_2: "Discards",

  OUT_ERRORS_1: "Out",
  OUT_ERRORS_2: "Errors",

  IN_OCTETS_POPUP: "Total number of octets received on the interface.",
  IN_UCAST_POPUP: "Number of unicast packets delivered to a higher-layer protocol.",
  IN_NUCAST_POPUP: "Number of non-unicast packets (broadcast or multicast) delivered to a higher-layer protocol.",
  IN_DISCARDS_POPUP: "Total number of incoming frames whose transmission attempt was abandoned due to insufficient resources.",
  IN_ERRORS_POPUP: "Number of incoming packets that contained errors preventing them from being delivered to a higher-layer protocol.",
  IN_UNKNOWN_PROTOS_POPUP: "Number of packets received through the interface that were discarded due to an unknown or unsupported protocol.",

  OUT_OCTETS_POPUP: "The total number of octets transmitted out of the interface.",
  OUT_UCAST_POPUP: "The total number of packets that higher-layer protocols requested to be transmitted to a unicast subnet address, including those that were discarded or not sent.",
  OUT_NUCAST_POPUP: "The total number of packets that higher-layer protocols requested to be transmitted to a non-unicast address (broadcast or multicast), including those that were discarded or not sent.",
  OUT_DISCARDS_POPUP: "Total number of outgoing frames whose transmission attempt was abandoned due to insufficient resources.",
  OUT_ERRORS_POPUP: "The number of outgoing packets that could not be transmitted due to errors.",

  //  ---------------------------- Log ----------------------------
  LOG_CSV_EXPORT_NAME: "Log.xlsx",
  LOG_CSV_HEADER: "Time,IP,MAC,Product name,Type,Event\n",

  //  ---------------------------- Ping Graph ----------------------------
  DEVICES: "Devices",
  DEVICES_TOOLTIP_1: "It is possible to view at most 5 devices at the same time.",
  DEVICES_TOOLTIP_2: "Devices with duplicate IP are not shown until the problem is resolved.",
  TIME_DP: "Time: ",
  TIME: "Time",

  //  ---------------------------- Device Status ----------------------------

  // ---------------------------- Page Scaling Modifiers ----------------------------

  // ---------------------------- Configuration page related ----------------------------
  LOGIN_CREDENTIALS_FAILURE: "An error occurred while signing in: incorrect username or password.",
  LOGIN_GENERAL_FALIURE: "An error occurred while signing in:",
  LOGIN: "LOGIN",
  USERNAME: "Username",
  PASSWORD: "Password",
  NEW_PASSWORD: "New password",
  REPEAT_PASSWORD: "Repeat password",
  ENTER: "Sign in",
  LOGOUT: "Sign out",
  HOSTNAME: "Hostname",
  TIMEZONE: "Timezone",
  SOFTWARE_UPDATE: "Software update",
  CURRENT_VERSION: "Current version: ",
  REPORT: "Report",
  CHANGE_LOGIN: "Change login",
  CHANGE: "Change",
  UPDATE: "Update",

  GPG_ALERT_MESSAGE: "Only files with the .gpg extension can be sent.",

  SEND_FILE_SUCCESS: "The file was sent successfully.",
  SEND_FILES_SUCCESS: "The files were sent successfully.",
  SEND_FILE_SUCCESS_WARNING: "Remember to check whether your computer's network adapter is on the same subnet as the IP address: ",
  SEND_FILE_FAILURE: "An error occurred while sending the file.",
  SEND_FILES_FAILURE: "An error occurred while sending the files.",
  SEND_FILE_WAITING: "Sending the file.",
  SEND_FILES_WAITING: "Sending the files.",
  SEND_FILE_WRONG_FILENAME: "Invalid filename. The update file must be named: updateEthIP.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "The update file was corrupted during upload.",
  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "An error occurred while sending the following GSDML files: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "An error occurred while removing the following GSDML files: ",
  SEND_CONFIG_SUCCESS: "The settings were sent successfully.",
  SEND_CONFIG_FAILURE: "An error occurred while sending the settings.",
  SEND_CONFIG_WAITING: "Sending the settings.",
  SEND_CONFIG_WAITING_2: "Finishing the settings upload.",
  SEND_CONFIG_DONE: "Settings sent.",
  START_MESSAGE_SUCCESS: "The monitor will start in 15 seconds.",
  START_MESSAGE_FAILURE: "An error occurred while starting the monitor.",
  STOP_MESSAGE_SUCCESS: "The monitor will stop in 15 seconds.",
  STOP_MESSAGE_FAILURE: "An error occurred while stopping the monitor.",
  WAITING: "Please wait a moment",
  CLEAN_LOG_SUCCESS: "The log was cleared successfully.",
  CLEAN_LOG_FAILURE: "An error occurred while clearing the log.",

  CHANGE_USERNAME_SUCCESS: "The username was changed successfully. Please sign in again.",
  CHANGE_USERNAME_FAILURE: "An error occurred while changing the username: ",
  USERNAME_TOO_SHORT: "The username must contain at least one character.",
  PASSWORD_MISSMATCH: "The entered passwords do not match",
  CHANGE_PASSWORD_SUCCESS: "The password was changed successfully. Please sign in again.",
  CHANGE_PASSWORD_FAILURE: "An error occurred while changing the password: ",

  VERIFY_THE_FOLLOWING_INFO: "Please check the following information:",
  INVALID_IP: "\n- The entered IP is invalid",
  INVALID_SUBMASK: "\n- The entered subnet mask is invalid",
  INVALID_GATEWAY: "\n- The entered gateway is invalid",
  LOOPBACK_IP: "\n- The loopback IP (127.0.0.1) cannot be used as the monitor IP",
  LOOPBACK_IP_NTP: "\n- The loopback IP (127.0.0.1) cannot be used as the NTP server IP",
  TAG_TOO_LONG: "\n- The tag cannot exceed 30 characters",
  SELECT_TIMEZONE: "\n- A timezone must be selected to configure the NTP server",
  SAME_SUBNET_IP_1: "\n- The office interface IP address cannot be on the same subnet as the ETHERNET interface.",
  SAME_SUBNET_IP_2: "\n- The ETHERNET interface IP address cannot be on the same subnet as the office interface.",
  SUBNET_OVERLAP_OFFICE: "\n- TS Monitor EtherNet/IP detected an address overlap between the ETHERNET interface subnet and the office interface subnet. Therefore, the office interface cannot be configured with the chosen IP address and mask.",
  SUBNET_OVERLAP_ETHERNET: "\n- TS Monitor EtherNet/IP detected an address overlap between the ETHERNET interface subnet and the office interface subnet. Therefore, the ETHERNET interface cannot be configured with the chosen IP address and mask.",
  SUBNET_OVERLAP_WLAN: "\n- TS Monitor EtherNet/IP detected an address overlap between the ETHERNET interface subnet and the WLAN subnet. Therefore, the WLAN cannot be configured with the chosen IP address and mask.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- TS Monitor EtherNet/IP detected an address overlap between the ETHERNET interface subnet and the WLAN subnet. Therefore, the ETHERNET interface cannot be configured with the chosen IP address and mask.",
  ZERO_IP_MSG: "\n- IP 0.0.0.0 cannot be used as the monitor IP",
  ZERO_IP_MASK_MSG: "\n- IP 0.0.0.0 cannot be used as the network mask",
  BROADCAST_IP_MSG: "\n- The network broadcast IP cannot be used as the monitor IP",
  NETWORK_IP_MSG: "\n- The network IP cannot be used as the monitor IP",
  BROADCAST_GATEWAY_MSG: "\n- The network broadcast IP cannot be used as the gateway IP",
  NETWORK_GATEWAY_MSG: "\n- The network IP cannot be used as the gateway IP",
 
  GENERATING_REPORT_WAITING: "Generating report, please wait",

  ALTER_USERNAME: "CHANGE USERNAME",
  ALTER_PASSWORD: "CHANGE PASSWORD",

  SELECT_FILE: "Please select a file to send",
  SELECT_AT_LEAST_ONE_FILE: "Please select at least one file to send",
  SELECT_AT_LEAST_ONE_FILE_TO_DELETE: "Please select at least one file to remove",

  DO_NOT_CLOSE_THIS_TAB: "Keep this tab open to monitor the update.",
  UPDATING_MONITOR_FILES: "Updating files on the monitor. Please wait.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Files updated; preparing to restart the monitor.",
  RESTARTING_MONITOR_WAIT: "Restarting the monitor. Please wait a few minutes.",
  MONITOR_RESTART_SUCCESS: "The monitor was restarted successfully.",
  MONITOR_RESTART_FAILURE: "An error occurred while restarting the monitor.",
  UPDATE_SUCCESS: "The update was completed successfully!",
  UPDATE_ERROR_STRING: "The following error occurred while updating the monitor: ",

  // ------------------------------- NTP UPDATE STATUS ----------------------------

  NTP_INFO_TURNED_OFF_SUCCESS: "The NTP server was turned off successfully.",
  NTP_INFO_TURNED_OFF_FAILURE: "An error occurred while turning off the NTP server.",
  TURN_OFF_DATE: "\nShutdown time: ",
  NTP_INFO_FAILURE: "Failed to synchronize with the server. If the error persists, contact the NTP server administrator.",
  SEND_NTP_CONFIG_WAITING: "Sending NTP server settings.",
  SEND_NTP_CONFIG_DONE: "NTP server settings sent.",

  PROCESSING_NTP_INIT: "Starting to process NTP server information.",
  PROCESSING_NTP_INFO: "Processing NTP server information.",
  PROCESSED_NTP_INFO: "NTP server information processed.",
  PROCESSING_NTP_ERROR: "An error occurred while sending information to the NTP server. Check that the server IP address is correct. If it is, also check that the NTP service is enabled and try again.",

  ITS_NECESSARY_TO_DISABLE_THE_MONITORING_FIRST: "Monitoring must be turned off before configuring the sweep.",
  MONITORING_QUESTION_ICON_INFO: "Turns active message sending and capture on or off. When disabled, the monitor does not send messages or retrieve data.",
  DEVICE_SEARCH_QUESTION_ICON_INFO: "Selects continuous (constant) or one-time discovery to reduce message traffic. In one-time discovery mode, new devices that appear on the network will not be found.",
  GSDML_QUESTION_ICON_INFO: "Loading GSDML files into TS Monitor greatly expands asset diagnostic capabilities, enabling the interpretation of manufacturer-specific information that can only be displayed when these files are loaded into the monitor.",


  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Change at least one field to update the interface settings.",
  TAG_WAS_CHANGED_SUCCESSFULLY: "The monitor tag was changed successfully.",
  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nRemember to update the address in your browser to: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "Interface settings were updated successfully!",

  CONTINUOUS: "Continuous",
  UNIQUE: "One-time",

  ALTER_MONITOR_CONFIG: "Are you sure you want to change the monitor settings?",
  RESTART_SYSTEM: " Restart System",
  CONFIRM_RESTART_SYSTEM: "Are you sure you want to restart the system?",
  RESTART_SYSTEM_FAILURE: "An error occurred while trying to restart the system.",
  RESTART_SYSTEM_SUCCESS: "The restart request was sent successfully. Wait approximately 3 minutes for the system to restart completely.",

  PING_LIMIT: "Ping limit",
  ALTER_PING_LIMIT_SUCCESS: "The ping limit was successfully changed.",
  ALTER_PING_LIMIT_ERROR: "An error occurred while changing the ping limit.",

  PING_LIMIT_POPUP_1: "The ping limit is the average ping value above which it is considered that there is a problem with the device.",
  PING_LIMIT_POPUP_2: "Each time a device exceeds this value, an event will be recorded in TS Expert.",
  PING_LIMIT_POPUP_3: "The ping unit of measurement is milliseconds (ms).",
  PING_LIMIT_POPUP_4: "The minimum allowed value for the ping limit is 0 ms.",
  PING_LIMIT_POPUP_5: "The maximum allowed value for the ping limit is 10,000 ms (10 seconds).",

  PING_LIMIT_OUT_OF_BOUNDS: "The ping limit must be between 0 and 10,000 ms (10 seconds).",

  RATE: "Rate",
  PACKET_LOSS_RATE: "Lost ping rate limit",
  PACKET_LOSS_POPUP: "The lost ping rate limit determines, for all devices, from which percentage of lost pings TS Expert will record an event.",

  ALTER_PACKET_LOSS_RATE_LIMIT_SUCCESS: "The lost ping rate limit was successfully changed.",
  ALTER_PACKET_LOSS_RATE_LIMIT_ERROR: "An error occurred while changing the lost ping rate limit.",
  PACKET_LOSS_RATE_LIMIT_OUT_OF_BOUNDS: "The lost ping rate limit must be between 0 and 100 (0-100%).",

  MEDIA_COUNTERS_INCREMENT: "Media Counters increment",
  INTERFACE_COUNTERS_INCREMENT: "Interface Counters increment",
  CLEAR: "Clear",

  RESET_MEDIA_COUNTERS_INCREMENT_SUCCESS: "Media Counters increments were successfully cleared (reset).",
  RESET_MEDIA_COUNTERS_INCREMENT_FAILURE: "An error occurred while resetting Media Counters increments.",

  RESET_INTERFACE_COUNTERS_INCREMENT_SUCCESS: "Interface Counters increments were successfully cleared (reset).",
  RESET_INTERFACE_COUNTERS_INCREMENT_FAILURE: "An error occurred while resetting Interface Counters increments.",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Ethernet interface configuration field.",
  ETHERNET_POPUP_2: "Used for monitoring and web access to monitor data.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Wireless interface configuration field, when an adapter is available.",
  WLAN_POPUP_2: "Used for monitoring and web access to monitor data.",

  SETUP: "Configure",

  SWEEP: "Sweep",
  SWEEP_POPUP_MSG: " Allows a custom sweep to be configured for up to 5 subnets.",

  TAG_CONFIG: "Network tag",
  TAG: "Tag",
  TEST_NETWORK: "Test network",
  TAG_CHANGE_FAILURE: "An error occurred while changing the monitor tag.",
  REASON_DP: "Reason: ",

  NTP_SERVER: "NTP Server",

  TURN_NTP_SERVER_ON: "Turn on NTP server",
  TURN_NTP_SERVER_ON_QUESTION: "Are you sure you want to turn on the NTP server? The monitor will need to be restarted.",

  NTP_INFO_TURNED_ON_SUCCESS: "The NTP server was turned on successfully.",
  NTP_INFO_TURNED_ON_FAILURE: "An error occurred while turning on the NTP server.",
  TURN_ON_DATE: "\nThe server time was updated to: ",
  INTERFACE_CONFIG: "Interface Settings",
  INTERFACE_ETHERNET_CONFIG: "ETHERNET Interface Settings",
  // ---------------------------- WLAN Config ----------------------------
  ALTER_MONITOR_WLAN_CONFIG: "Are you sure you want to change the monitor WLAN settings?",
  ALTER_OFFICE_INTERFACE_CONFIG_HEADER: "Configure office interface",
  ALTER_OFFICE_INTERFACE_CONFIG: "Are you sure you want to change the office interface settings?",
  ALTER_OFFICE_INTERFACE_CONFIG_2: "When using DHCP mode, make sure the office interface is not configured on the same subnet as the ETHERNET interface; otherwise, TS Monitor EtherNet/IP may behave unexpectedly.",

  CONNECTED: "Connected",
  DISCONNECTED: "Disconnected",

  WLAN_STATUS_POPUP_1: "Indicates the status of the monitor WLAN adapter.",
  WLAN_STATUS_POPUP_2: "WLAN settings cannot be changed when the adapter is turned off.",

  CONNECTION_STATUS_POPUP_1: "Indicates whether the monitor is connected to the configured WLAN network.",
  CONNECTION_STATUS_POPUP_1_1: "Indicates whether the monitor is connected to the configured Ethernet network.",
  
  WLAN_CONFIG_POPUP_1: "Settings cannot be changed while the WLAN adapter is turned off.",
  WLAN_CONFIG_POPUP_2: "It is highly recommended to change WLAN settings only when accessing the monitor through the wired network.",
  WLAN_CONFIG_POPUP_3: "When changing the IP address or mask, blank fields after the update strongly indicate that:",
  WLAN_CONFIG_POPUP_4: "Another device on the network already has the same IP address;",
  WLAN_CONFIG_POPUP_5: "The network mask is too restrictive and does not include the specified IP address.",

  ETHERNET_CONFIG_POPUP: "Configuration field for the Ethernet interface connected to the industrial network and used by TS Monitor for data capture.",
  WLAN_CONFIG_POPUP: "Configuration field for the wireless interface, when an adapter is available, used for monitoring and web access to TS Monitor data. This network is isolated from the Ethernet/Industrial network.",
  OFFICE_CONFIG_POPUP: "Configuration field for the Ethernet interface used for monitoring and web access to TS Monitor data. This network is isolated from the Ethernet/Industrial network.",
  BLACKLIST_CONFIG_POPUP: "Allows some TS Monitor data collection services to be excluded.",
  TS_EXPERT_CONFIG_POPUP: "Allows the nonconformities reported by the tool to be enabled or disabled.",

  WLAN_ADAPTER_NOT_FOUND_1: "TS Monitor EtherNet/IP could not find the WLAN adapter:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Check whether the adapter is disconnected or has a poor connection;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • If the adapter is neither disconnected nor poorly connected, try replacing it;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • If none of the options above resolve the problem, contact Toledo e Souza.",

  HOSTNAME_POPUP_1: "A hostname must contain between 2 and 64 characters to be valid.",
  HOSTNAME_POPUP_2: "It may contain only letters, numbers, periods, and hyphens, and must start and end with letters or numbers.",

  INVALID_HOSTNAME_1: "The hostname must contain between 2 and 64 characters.",
  INVALID_HOSTNAME_2: "The hostname may contain only letters, numbers, periods, and hyphens, and must start and end with letters or numbers.",

  HOSTNAME_CONFIG_SUCCESS: "The hostname was configured successfully.",
  HOSTNAME_CONFIG_ERROR: "An error occurred while configuring the hostname",
  MODE: "Mode",
  HIDDEN_SSID: "Hidden SSID",
  OPTIONAL: " (Optional)",
  FIXED_IP: "Fixed IP",

  TURNING_WLAN_OFF_WAITING: "Turning off the WLAN adapter. Please wait.",
  TURNING_WLAN_ON_WAITING: "Turning on the WLAN adapter. Please wait.",

  INVALID_DNS: "\n- The entered DNS is invalid",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Change at least one field to update the WLAN settings.",
  UPDATE_WLAN_CONFIG_SUCCESS: "WLAN settings were updated successfully!",
  UPDATE_OFFICE_INTERFACE_CONFIG_SUCCESS: "Office interface settings were updated successfully!",
  UPDATE_WLAN_CONFIG_ERROR: "Could not connect to the WLAN network. If the problem persists, try restarting the monitor or WLAN router.",
  UPDATE_OFFICE_INTERFACE_CONFIG_ERROR: "Error configuring the Office interface. If the problem persists, try restarting the monitor or router.",

  WLAN_STATUS: "WLAN Adapter",
  WLAN_CONFIG: "WLAN Settings",
  CONNECTION_STATUS: "Connection status",

  WLAN_ADAPTER_ON: "On",
  WLAN_ADAPTER_OFF: "Off",
  NETWORK_NAME_1: "Network name",
  SEND_WLAN_CONFIG_WAITING: "Sending settings. Please wait; this may take about one minute.",
  LOADING_WAITING: "Loading information. Please wait.",
  WLAN_INFO: "WLAN Information",
  ETHERNET_OFFICE_INFO: "Office ETHERNET Information",
  IP_PLACEHODLER: "192.168.2.220",
  SSID: "SSID",
  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH: "Signal strength",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY: "Frequency",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL: "Channel",
  QUALITY: "Quality",
  QUALITY_PLACEHOLDER: "Quality",
  SUBMASK: "Mask",
  GATEWAY: "Gateway",
  MASK: "Mask",
  ZERO_TRAFFIC: "0.00 Kbps",
  DNS: "DNS",

  ETHERNET_INTERFACE: "ETHERNET Interface",

  OFFICE_INTERFACE: "OFFICE Interface",

  // ---------------------------- Sweep Page ----------------------------
  PERSONALIZED_SWEEP: "Custom scan",

  SWEEP_ON: "On",
  SWEEP_OFF: "Off",
  BANDS: "Ranges",

  FIRST_BAND: "1st Range",
  SECOND_BAND: "2nd Range",
  THIRD_BAND: "3rd Range",
  FOURTH_BAND: "4th Range",
  FIFTH_BAND: "5th Range",

  BEGINNING: "Start",
  END: "End",

  ALERT_MESSAGE_PLACEHOLDER: "The fields in the following ranges have issues: ",

  FIRST_SUBNETWORK_ADDRESS_NOT_VALID: "\n - The 1st range address is invalid",
  FIRST_SUBNETWORK_START_LESS_THAN_FINISH: "\n - The start address of the 1st range is greater than or equal to its end address",
  FIRST_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - The 1st range has unfilled fields",

  SECOND_SUBNETWORK_ADDRESS_NOT_VALID: "\n - The 2nd range address is invalid",
  SECOND_SUBNETWORK_START_LESS_THAN_FINISH: "\n - The start address of the 2nd range is greater than or equal to its end address",
  SECOND_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - The 2nd range has unfilled fields",

  THIRD_SUBNETWORK_ADDRESS_NOT_VALID: "\n - The 3rd range address is invalid",
  THIRD_SUBNETWORK_START_LESS_THAN_FINISH: "\n - The start address of the 3rd range is greater than or equal to its end address",
  THIRD_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - The 3rd range has unfilled fields",

  FOURTH_SUBNETWORK_ADDRESS_NOT_VALID: "\n - The 4th range address is invalid",
  FOURTH_SUBNETWORK_START_LESS_THAN_FINISH: "\n - The start address of the 4th range is greater than or equal to its end address",
  FOURTH_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - The 4th range has unfilled fields",

  FIFTH_SUBNETWORK_ADDRESS_NOT_VALID: "\n - The 5th range address is invalid",
  FIFTH_SUBNETWORK_START_LESS_THAN_FINISH: "\n - The start address of the 5th range is greater than or equal to its end address",
  FIFTH_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - The 5th range has unfilled fields",

  SWEEP_DATA_SENT_SUCCESSFULLY: "Scan settings were saved successfully.",
  SWEEP_DATA_SENT_ERROR: "An error occurred while saving the scan settings.",
  SPECIFY_AT_LEAST_ONE_SUBNETWORK: "Specify at least one subnet to save the custom scan.",

  UNABLE_TO_SAVE_CUSTOM_SWEEP: "The custom scan cannot be saved because:",
  _THE: "- Range ",
  BAND_HAS_IPS_NOT_IN_SUBNETWORK: " contains IP addresses that are not in the monitor subnet",
  SENDING_DATA: "Sending data",

  // ---------------------------- PDF Report ----------------------------

  CONFORM_STRING: "Conform",
  CONFORM_W_RESTRICTION_STRING: "Conform with restrictions",
  NON_CONFORM_STRING: "Non-conform",

  GENERATING_REPORT_SUCCESS: "Report generated successfully. To save it, click save report below.",

  CONFORMITY: "Conformity",
  DROPDOWN_PLACEHOLDER: "Choose an option",
  GENERATE_REPORT: "Generate report",
  PING_GRAPHS: "Ping graphs",
  INCLUDE_IN_REPORT: "Include in report",
  CLIENT_INFO: "Client information",
  EXECUTING_COMPANY_INFO: "Executing company information",
  PROJECT_NAME_LABEL: "Project name",
  NETWORK_NAME_LABEL: "Network name",
  LOCATION_LABEL: "Location",
  COMPANY_NAME_LABEL: "Company name",
  ACCOUNTABLE_NAME_LABEL: "Responsible person",
  ADDRESS_LABEL: "Address",
  CITY_LABEL: "City",
  PHONE_LABEL: "Phone",
  EMAIL_LABEL: "Email",
  CLIENT_LOGO_LABEL: "Client logo",
  EXECUTING_COMPANY_LOGO_LABEL: "Executing company logo",
  ANNOTATIONS: "Notes",
  CONCLUSION: "Conclusion",

  HEADER_TEXT: "Data Report - TS Monitor EtherNet/IP",
  REPORT_EXPORT_NAME: "TS Monitor EtherNet/IP Report",

  GENERAL_REPORT: "General Report – TS Monitor EtherNet/IP",
  DATA_REPORT: "Data Report – TS Monitor EtherNet/IP",

  PROJECT_NAME: "- Project name:",
  NETWORK_NAME: "- Network name:",
  LOCATION: "- Location:",
  COMPANY_NAME: "- Company name:",
  ACCOUNTABLE_NAME: "- Responsible person:",
  COMPANY_ADDRESS: "- Address:",
  COMPANY_CITY: "- City:",
  COMPANY_TEL: "- Phone:",

  EXECUTING_COMPANY_NAME: "- Company name:",
  EXECUTING_ACCOUNTABLE_NAME: "- Responsible person:",
  EXECUTING_TEL: "- Phone:",
  EXECUTING_EMAIL: "- Email:",

  MONITORING_INFO: "Monitoring information",
  NETWORK_TAG_DP: "- Network tag: ",
  NETWORK_NAME_DP: "- Network name: ",
  MONITOR_IP: "- Monitor IP: ",
  MONITOR_SUBMASK_DP: "- Monitor mask: ",
  GATEWAY_DP: "- Gateway: ",
  DNS_DP: "- DNS: ",
  MODO_DP: "- Configuration mode: ",
  MONITOR_VERSION_DP: "- Monitor version: ",
  MONITOR_TIME_ON_DP: "- Uptime: ",
  MEASUREMENT_INTERVAL_DP: "- Measurement interval: ",
  REPORT_GENERATION: "- Report generated on: ",
  NUM_OF_DEVICES_DP: "- Number of devices found: ",
  NETWORK_AVAILABILITY_DP_2: "- Network availability: ",
  ETHERNET_INFO: "ETHERNET information",

  IP_DP: "- IP: ",
  MASK_DP: "- Mask: ",

  SUMMARY: "Summary",
  OVERVIEW: "Overview",
  LIVE_LIST: "Live List",
  INVENTORY: "Inventory",
  PORTS: "Ports",
  NETWORK: "Network",
  TOPOLOGY: "Topology",
  MEDIA_COUNTERS: "Media Counters",
  INTERFACE_COUNTERS: "Interface Counters",
  LOG: "Log",
  PING_GRAPH: "Ping graph",
  DISCLAIMER: "Disclaimer",

  OVERVIEW_DOTS: ".....................................................................................................................................",
  LIVE_LIST_DOTS: "........................................................................................................................................",
  INVENTORY_DOTS: ".......................................................................................................................................",
  PORTS_DOTS: ".............................................................................................................................................",
  NETWORK_DOTS: "........................................................................................................................................",
  TOPOLOGY_DOTS: ".....................................................................................................................................",
  MEDIA_COUNTERS_DOTS: "............................................................................................................................",
  INTERFACE_COUNTERS_DOTS: ".......................................................................................................................",
  LOG_DOTS: "................................................................................................................................................",
  PING_GRAPH_DOTS: "....................................................................................................................................",
  DISCLAIMER_DOTS: ".....................................................................................................................................",
  DISCLAIMER_DOTS_2: "....................................................................................................................................",

  OVERVIEW_PAGE_TITLE: "1. - Overview",
  LIVE_LIST_PAGE_TITLE: "1. - Live List",
  INVENTORY_PAGE_TITLE: "2. - Inventory",
  PORTS_PAGE_TITLE: "3. - Ports",
  NETWORK_PAGE_TITLE: "4. - Network",
  TOPOLOGY_PAGE_TITLE: "5. - Topology",
  MEDIA_COUNTERS_PAGE_TITLE: "5. - Media Counters",
  INTERFACE_COUNTERS_PAGE_TITLE: "6. - Interface Counters",
  LOG_PAGE_TITLE: "7. - Log",
  PING_GRAPH_PAGE_TITLE: "8. - Ping Graph",

  TS_MONITOR_VER_DP: "TS Monitor EtherNet/IP - Version ",
  NETWORK_STATUS_DP: "Network state: ",
  DEVICE_DATA: "Device data",

  CONTROLLERS_DP: "Controllers: ",
  DEVICES_DP: "Devices: ",
  SUPERVISORS_DP: "Supervisors: ",
  OTHER_DEVICES_DP: "Other devices: ",
  FAULTS_DP: "Faults: ",
  ALARMS_DP: "Alarms: ",
  IN_TRAFFIC_DP: "Incoming Ethernet traffic: ",
  OUT_TRAFFIC_DP: "Outgoing Ethernet traffic: ",

  MAC: "MAC",
  MACS: "MACs",
  IP: "IP",
  SNMP: "SNMP",
  NEIGHBOUR_PORT_1: "Neighbor",
  NEIGHBOUR_PORT_2: "port",
  NEIGHBOUR_IP: "Neighbor IP",

  DUPLICATE_IP_STRING: "Duplicate IP",

  END_OF_REPORT: "End of report",
  DISCLAIMER_TEXT: "The data and values presented in this report are merely auxiliary for the EtherNet/IP specialist, such that any correction indication must be made by the user. For this reason, follow-up by a certified EtherNet/IP engineer or the technician responsible for the analysis is recommended in order to validate the information provided by the product. Therefore, Toledo & Souza exempts itself from any liability, loss, or damage, direct or indirect, caused by interpretations of the software, offering no warranty regarding the integrity, quality, or adequacy of the information provided, since it depends on the technical analysis of a qualified professional. In the absence of such a professional, the user assumes the risk that the content may be inaccurate, incomplete, or may not meet their needs and requirements.",

  PROTOCOL: "Protocol",
  CONFIG_METHOD: "Configuration method",
  CURRENT_PING: "Current ping",
  MEDIUM_PING: "Average ping",
  LOST_PACKET_PERC: "Lost pings (%)",

  PRODUCT_NAME: "Product name",
  PRODUCT_NAMES: "Product names",
  VENDOR_ID: "Vendor ID",
  REVISION: "Revision",
  PRODUCT_CODE: "Product Code",
  SERIAL_NUMBER: "Serial Number",
  DEVICE_TYPE: "Device type",
  DEVICE_TYPE_1: "Device",
  DEVICE_TYPE_2: "type",

  PRODUCT_NAME_N: "Product\nname",
  INTERFACE_TYPE: "Interface\ntype",
  DUPLEX_MODE: "Duplex\nmode",
  INTERFACE_SPEED: "Interface\nspeed",
  NEGOTIATION_STATUS: "Negotiation\nstatus",
  HARDWARE_FAILURE: "Hardware\nfault",
  INTERFACE_STATE: "Interface\nstate",
  LINK_STATUS: "Link\nstatus",

  ACTIVE: "Active",
  INACTIVE: "Inactive",

  NETWORK_TOPOLOGY: "Network topology",
  NETWORK_STATUS: "Network Status",
  ACD_CAPABLE: "ACD Capable",
  ACD_STATUS: "ACD Status",
  ANNOUNCE_BASED: "Announce-based Ring Node",
  BEACON_BASED: "Beacon-based Ring Node",
  FLUSH_TABLE_CAPABLE: "Flush Table Frame Capable",
  REDUNDANT_GATEWAY_CAPABLE: "Redundant\nGateway Capable",
  SUPERVISOR_CAPABLE: "Supervisor\nCapable",

  ALIGNMENET_ERRORS: "Alignment\nErrors",
  CARRIER_SENSE_ERRORS: "Carrier Sense Errors",
  FCS_ERRORS: "FCS\nErrors",
  SINGLE_COLLISIONS: "Single\nCollisions",
  MULTIPLE_COLLISIONS: "Multiple\nCollisions",
  LATE_COLLISIONS: "Late\nCollisions",
  EXCESSIVE_COLLISIONS: "Excessive Collisions",
  SQE_TEST_ERRORS: "SQE\nTest\nErrors",
  DEFERRED_TRANSMISSION: "Deferred Transmission",
  FRAME_TOO_LONG: "Frame\nToo\nLong",
  MAC_TRANSMIT_ERRORS: "MAC\nTransmit\nErrors",
  MAC_RECEIVE_ERRORS: "MAC\nReceive\nErrors",

  TRAFFIC_KBPS: "Traffic (Kbps)",
  IN_OCTETS: "In\nOctets",
  IN_UCAST_PKTS: "In\nUcast\nPackets",
  IN_NUCAST_PKTS: "In\nNUcast\nPackets",
  IN_DISCARDS: "In\nDiscards",
  IN_ERRORS: "In\nErrors",
  IN_UNKNOWN_PROTOS: "In\nUnknown\nProtos",
  OUT_OCTETS: "Out\nOctets",
  OUT_UCAST_PKTS: "Out\nUcast\nPackets",
  OUT_NUCAST_PKTS: "Out\nNUcast\nPackets",
  OUT_DISCARDS: "Out\nDiscards",
  OUT_ERRORS: "Out\nErrors",

  // ---------------------------- OTHERS ----------------------------
  BEFORE_MONITOR_INIT_STR: "Before the last startup",
  REMOVE_DEVICE_SUCCESS: "The device will be removed within 30 seconds.",
  REMOVE_DEVICE_FAILURE: "An error occurred while removing the device: ",
  OK_STRING: "OK",
  WITH_DIAGNOSTIC_STRING: "With alarm",
  WITH_FAILURE_STRING: "With fault",
  UNKNOWN: "Unknown",
  NO_EVENT: "No event",
  LOG_WAITING: "Loading log data",
  GO_TO_LOG_OR_REMOVE_POSITIONING: "Remove device",
  ASK_DELETE_OR_LOG_1: "Do you want to remove this device with duplicate IP from the list?",
  ASK_DELETE_OR_LOG_2: "Do you want to remove this device with possible IP loss from the list?",
  DELETE: "Delete",
  GO_TO_LOG: " Go to log",
  MEDIA_COUNTERS_PLACEHOLDER: "Filter by IP",

  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filter by IP, MAC, or protocol",
  INVENTORY_INPUT_TEXT_PLACEHOLDER: "Filter by IP, MAC, or product name",
  PORTS_INPUT_TEXT_PLACEHOLDER: "Filter by IP, MAC, or product name",
  NETWORK_INPUT_TEXT_PLACEHOLDER: "Filter by IP, or network topology",

  TOPOLOGY_INPUT_TEXT_PLACEHOLDER: "Filter by IP or MAC",
  TRAFFIC_INPUT_TEXT_PLACEHOLDER: "Filter by IP, name, or model",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filter by IP, MAC, product name, or type",
  GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER: "Search device by IP",
  FAULTS: "Faults",
  STATISTICS: "Statistics",
  BILLIONS_OF: "Billions of",
  ONE_MILLION_OF: "Million",
  ONE_BILLION_OF: "Billion",
  MILLIONS_OF: "Millions of",
  THOUSAND: "Thousand",
  THOUSAND_NO_CAPITAL: " thousand",
  MILLION_NO_CAPITAL: " million",
  MILLIONS_NO_CAPITAL: " millions",
  BILLION_NO_CAPITAL: " billion",
  BILLIONS_NO_CAPITAL: " billions",
  LAST_EVENT: "Last event: ",
  UP_TIME: "Uptime:",
  MONITORING: "Monitoring: ",
  TURNED_OFF: "Off ",
  TURNED_ON: "On ",
  MONITORING_ON_TOOLTIP: "Monitoring service is on.",
  MONITORING_OFF_TOOLTIP: "Monitoring service is off. To turn it on, access the MONITORING window in the Settings tab.",
  MONITORING_GETTING_CONNECTION: "Establishing connection.",

  ALARMS_QUESTION_INFO: "Indicates the number of alarms reported by devices. Alarms indicate abnormal device conditions, such as short circuits, power supply problems, missing modules, and others.",
  FAULTS_QUESTION_INFO: "Indicates how many times an EtherNet/IP device did not respond to messages sent by TS Monitor.",

  TYPE: "Type",
  DEVICE: "Device",

  // ---------------------------- GRAPH COLORS ----------------------------

  // ---------------------------- EXPERT ERROR TYPES ----------------------------





  // ---------------------------- TS EXPERT ----------------------------
  TS_EXPERT_REPORT_EXPORT_NAME: "Action List - TS Expert - EtherNet/IP",

  TS_EXPERT_POPUP_1: "This tab displays TS Expert information.",
  TS_EXPERT_POPUP_2: "This tool is an expert system developed to optimize and speed up the analysis of the main issues detected by TS Monitor EtherNet/IP in EtherNet/IP networks.",
  TS_EXPERT_POPUP_3: "In an automated way, maintenance, engineering, and related teams can obtain an action list with different events, their possible causes, solution suggestions, and the devices on which they were detected.",
  TS_EXPERT_POPUP_4: "Using TS Expert does not eliminate the need for human analysis, nor does it replace the ability to correlate and interpret data.",

  TS_EXPERT: "TS Expert",
  EVENTS_LIST: "Event list",
  DETECTED_ON: "Detected on: ",
  INCREMENT_DETECTED_ON: "Most recent increment detected on: ",
  EXPORT_ACTIONS_LIST: "Export action list",
  GENERATING_TS_EXPERT_REPORT_SUCCESS: "Report generated successfully. To save it, click save report.",

  ACTIONS: "Actions",

  NO_PROBLEM_DETECTED: "TS Expert did not detect any problem on the network.",
  NO_EVENTS_TO_BE_ANALYZED: "There are no events to be analyzed.",

  NO_EVENT_SELECTED: "No event selected",
  CHOOSE_AN_EVENT: "Choose an event to view the suggested actions.",

  DETAILING: "Details",

  CHECKED: "Checked",
  BATCH_CHECK: "Check all",

  PROBLEM_CHECKED: "The event was successfully checked",
  PROBLEM_CHECK_ERROR: "An error occurred while checking the event.",

  QUANTITY_DP: "Quantity: ",

  DEVICE_HAS_MEDIA_COUNTERS_PROBLEMS: "The device has Media Counters increments on the following ports:",
  DEVICE_HAS_INTERFACE_COUNTERS_PROBLEMS: "The device has Interface Counters increments on the following ports:",

  PORT_IS_STILL_INACTIVE: "The port is still inactive",
  MARK_PROBLEM_AS_SOLVED: "Are you sure you want to mark the event as checked?",

  LAST_UPDATED: "Last updated on: ",
  THIS_COMPUTER_TIME: " (This computer's time)",

  // ------------------------------ PING LIMIT ------------------------------
  GROUP_PING_LIMIT_HEADER: "There are devices on the network that exceeded the ping limit value.",
  THE_LIMIT_VALUE_IS: "The limit value is: ",

  PING_LIMIT_EXCEEDED: "Ping limit exceeded",

  PING_LIMIT_HEADER_1: "The device with IP ",
  PING_LIMIT_HEADER_2: " exceeded the ping limit.",

  PING_LIMIT_DESCRIPTION_1: "IP: ",
  PING_LIMIT_DESCRIPTION_2: "MAC: ",
  PING_LIMIT_DESCRIPTION_3: "Product name: ",
  PING_LIMIT_DESCRIPTION_4: "Recorded ping: ",

  PING_LIMIT_SUGGESTION_1: "When a device exceeds the ping limit value, the following is suggested:",
  PING_LIMIT_SUGGESTION_2: "Traffic problems:",
  PING_LIMIT_SUGGESTION_3: "Use the Interface Counters tab and review the applications using the link; check whether they are compatible with the available infrastructure;",
  PING_LIMIT_SUGGESTION_4: "Check whether the available bandwidth meets the application requirements (use of Fast or Gigabit Ethernet switches).",

  PING_LIMIT_SUGGESTION_5: "High processing usage on equipment and switches:",
  PING_LIMIT_SUGGESTION_6: "Review the application's data consumption;",
  PING_LIMIT_SUGGESTION_7: "Review the equipment temperature.",

  PING_LIMIT_SUGGESTION_8: "Propagation delay (excessive cable length):",
  PING_LIMIT_SUGGESTION_9: "Identify the cable length, visually when marked on the cable, or by using testers or certifiers.",

  NO_DEVICE_EXCEEDED_PING_LIMIT: "There are no devices on the network that exceeded the ping limit",

  // ------------------------------ DUPLICATE IP ------------------------------
  GROUP_DUPLICATE_IP_LIST_HEADER: "There are devices on the network with duplicate IP.",
  GROUP_DUPLICATE_IP_LIST_DESCR: "Please check your network.",

  DEVICES_WITH_DUPLICATE_IP: "Devices with duplicate IP",
  DUPLICATE_IP_CARD_DESC: "The devices below are using the IP address ",

  DUPLICATE_IP_SUGGESTION_1: "When there are duplicate IPs on the network, the following is suggested:",
  DUPLICATE_IP_SUGGESTION_2: "Check the physical MAC addresses to identify the devices with the IP address conflict and correct the address settings.",
  NO_DEVICES_WITH_DUPLICATE_IPS: "There are no devices on the network with duplicate IPs",

  // ------------------------------ DHCP ------------------------------
  DHCP_LIST_HEADER: "There are devices on the network whose IPs were configured by DHCP.",
  DHCP_LIST_DESCR: "Ideally, the configuration method should be static.",

  DHCP_CONFIG_METHOD: "DHCP configuration method",

  DHCP_SUGGESTION_1: "When a device's configuration method is DHCP, the following is suggested:",
  DHCP_SUGGESTION_2: "Check whether DHCP addressing is being used. This is not recommended for an industrial environment, since most applications use fixed IP addresses and automatic configuration may generate conflicts if not planned precisely. For this reason, it is suggested to use fixed IP addressing.",

  NO_DEVICES_CONFIGURED_BY_DHCP: "There are no devices on the network configured by DHCP",

  // ------------------------------ PACKET LOSS ------------------------------
  GROUP_PACKET_LOSS_LIST_HEADER: "There are devices on the network with % of lost pings above the limit rate.",
  GROUP_PACKET_LOSS_LIST_DESCR: "Please check your network.",

  PACKET_LOSS_GREATER_ONE_PERCENT: "% of lost pings above the limit rate",
  PACKET_LOSS_DESCRIPTION: "Lost pings (%): ",

  PACKET_LOSS_SUGGESTION_1: "When a device's % of lost pings is above the limit rate, the following is suggested:",
  PACKET_LOSS_SUGGESTION_2: "Check whether the target device is properly powered and installed;",
  PACKET_LOSS_SUGGESTION_3: "Check for electromagnetic interference, if it is intermittent or has non-linear behavior;",
  PACKET_LOSS_SUGGESTION_4: "Perform cable certification and testing to rule out physical media problems;",
  PACKET_LOSS_SUGGESTION_5: "Check the traffic on the link connecting the devices;",
  PACKET_LOSS_SUGGESTION_6: "Check device memory and CPU usage;",
  PACKET_LOSS_SUGGESTION_7: "Check device temperature.",
  PACKET_LOSS_SUGGESTION_8: "Ping packets considered lost are those that were sent but did not return to the device that sent them.",
  OBS: "NOTE: ",

  NO_DEVICES_SURPASSED_PING_LOST_LIMIT: "There are no devices on the network whose % of lost pings exceeded the limit rate",

  // ------------------------------ INACTIVE PORT ------------------------------
  INACTIVE_PORT_LIST_HEADER: "There are devices on the network whose ports were deactivated.",
  INACTIVE_PORT_LIST_DESCR: "Please check your network.",

  INACTIVE_PORT: "Inactive port",
  PORT: "Port",

  INACTIVE_PORT_SUGGESTION_1: "When a port becomes inactive, the following is suggested:",
  INACTIVE_PORT_SUGGESTION_2: "Check whether the device connected at the cable end is powered;",
  INACTIVE_PORT_SUGGESTION_3: "Check whether the cable has been broken;",
  INACTIVE_PORT_SUGGESTION_4: "Check the port configuration, in case it was disabled.",

  NO_DEVICES_WITH_INACTIVE_PORTS: "There are no devices on the network with inactive ports (was active and then became inactive)",

  // ------------------------------ NOT IN AUTONEGOTIATION ------------------------------
  NOT_IN_AUTONEGOTIATION_LIST_HEADER: "There are devices on the network whose auto-negotiation failed on at least one port.",
  NOT_IN_AUTONEGOTIATION_LIST_DESCR: "Please check your network.",

  AUTONEGOTIATION_FAILED: "Auto-negotiation failed",

  NOT_IN_AUTONEGOTIATION_SUGGESTION_1: "When a port's auto-negotiation fails, the following is suggested:",
  NOT_IN_AUTONEGOTIATION_SUGGESTION_2: "Check the cabling condition (poor connector assembly, damaged or broken cables, low-quality cables and connectors, or excessively long cabling for the category);",
  NOT_IN_AUTONEGOTIATION_SUGGESTION_3: "Check the port settings on both ends (it is possible that some communication rate or duplex mode has been forced and is incompatible with the settings of the port on the other end);",
  NOT_IN_AUTONEGOTIATION_SUGGESTION_4: "Check whether the hardware is incompatible (different implementations of the auto-negotiation standard may generate incompatibility);",
  NOT_IN_AUTONEGOTIATION_SUGGESTION_5: "Auto-negotiation does not apply to fiber optic links.",

  NO_DEVICES_WITH_AUTONEGOTIATION_FAULT: "There are no devices on the network with ports whose auto-negotiation failed",

  // ------------------------------ NOT IN FULL DUPLEX ------------------------------
  NOT_IN_FULL_DUPLEX_LIST_HEADER: "There are devices on the network with ports not configured in Full Duplex mode.",
  NOT_IN_FULL_DUPLEX_LIST_DESCR: "Please check your network.",

  PORT_NOT_IN_FULL_DUPLEX: "Port not configured in Full Duplex mode",

  NOT_IN_FULL_DUPLEX_SUGGESTION_1: "When a port duplex mode is not Full Duplex, the following is suggested:",
  NOT_IN_FULL_DUPLEX_SUGGESTION_2: "Check whether the port configuration is set to auto or forced;",
  NOT_IN_FULL_DUPLEX_SUGGESTION_3: "Check the cabling integrity.",
  NOT_IN_FULL_DUPLEX_SUGGESTION_4: "Using Full Duplex allows greater use of total bandwidth (sending and receiving) and shorter response times.",

  NO_DEVICES_WITHOUT_FULL_DUPLEX: "There are no devices on the network with ports whose duplex mode is not Full Duplex",

  // ------------------------------ INTERFACE SPEED ------------------------------
  INTERFACE_SPEED_LIST_HEADER: "There are devices on the network with interface speed < 100 Mbps.",
  INTERFACE_SPEED_LIST_DESCR: "Please check your network.",

  INTERFACE_SPEED_LESSER_THAN_100: "Interface speed < 100 Mbps",

  INTERFACE_SPEED_SUGGESTION_1: "When a port interface speed is < 100 Mbps:",
  INTERFACE_SPEED_SUGGESTION_2: "Even if the application does not require more than 10 Mbit bandwidth, occasional traffic from sporadic access or maintenance may cause loss of communication.",
  INTERFACE_SPEED_SUGGESTION_3: "It is suggested to use at least 100 Mbps for normal links and 1 Gbps for redundancy rings and priority or high-demand links.",

  NO_DEVICES_WITH_SLOW_PORTS: "There are no devices on the network with ports whose interface speed is < 100 Mbps",

  // ------------------------------ HARDWARE FAULT ------------------------------
  HARDWARE_FAULT_LIST_HEADER: "There are devices on the network with local hardware fault on at least one of their ports.",
  HARDWARE_FAULT_LIST_DESCR: "Please check your network.",

  PORT_WITH_LOCAL_HARDWARE_FAULT: "Port with local hardware fault",

  HARDWARE_FAULT_SUGGESTION_1: "When a port has a local hardware fault, the following is suggested:",
  HARDWARE_FAULT_SUGGESTION_2: "Replace or repair the device, and change the port being used.",

  NO_DEVICES_WITH_PORT_HARDWARE_FAULT: "There are no devices on the network with ports that have a local hardware fault",

  // ------------------------------ ADDR CONFLICT ------------------------------
  ADDR_CONFLICT_LIST_HEADER: "There are devices on the network that detected address conflicts.",
  ADDR_CONFLICT_LIST_DESCR: "Please check your network.",

  ADDR_CONFLICT_DETECTED: "Address conflict detected",

  ADDR_CONFLICT_DETECTED_SUGGESTION_1: "When a device detects an address conflict, the following is suggested:",
  ADDR_CONFLICT_DETECTED_SUGGESTION_2: "Check the MAC physical address of the other device with the conflicting address and correct the logical IP address settings.",

  NO_DEVICES_WITH_ADDR_CONFLICT_DETECTED: "There are no devices on the network with address conflict",

  // ------------------------------ MEDIA COUNTERS ------------------------------
  MEDIA_COUNTERS_LIST_HEADER: "There are devices with media counters increment.",

  MEDIA_COUNTERS_HEADER: "Media Counters Increment",
  ALIGNMENT_ERROR_HEADER: "Alignment Errors Increment",
  CARRIER_SENSE_HEADER: "Carrier Sense Errors Increment",
  FCS_ERROR_HEADER: "FCS Errors Increment",
  SINGLE_COLLISION_HEADER: "Single Collisions Increment",
  MULTIPLE_COLLISIONS_HEADER: "Multiple Collisions Increment",
  LATE_COLLISIONS_HEADER: "Late Collisions Increment",
  EXCESSIVE_COLLISIONS_HEADER: "Excessive Collisions Increment",
  SQE_TEST_HEADER: "SQE Test Errors Increment",
  DEFERRED_TRANSMISSION_HEADER: "Deferred Transmissions Increment",
  FRAME_TOO_LONG_HEADER: "Frame Too Long Increment",
  MAC_TRANSMIT_HEADER: "MAC Transmit Errors Increment",
  MAC_RECEIVE_HEADER: "MAC Receive Errors Increment",
  MEDIA_COUNTERS_NOT_SUPPORTED: "The device does not support access to media counters",
  MEDIA_COUNTERS_NOT_ANSWERED_YET: "The device has not responded yet",

  MEDIA_COUNTERS_SUGGESTION_1: "When a device has Media Counters increment, the following is suggested:",
  MEDIA_COUNTERS_SUGGESTION_2: "Navigate to the Media Counters tab and click the button in the upper-right corner of the screen (as shown in the image below) to download the action suggestions PDF.",
  MEDIA_COUNTERS_SUGGESTION_3: "The document presents the possible causes for the increment of each Media Counter type.",

  MEDIA_COUNTERS_SUGGESTION_4: "Click the button below to download the action suggestions PDF. The document presents the possible causes for the increment of each Media Counter type.",

  DEVS_WITH_MEDIA_COUNTERS_EXPLANATION_1: "This list shows only the devices and respective ports that have increment in at least one type of media counter.",
  DEVS_WITH_MEDIA_COUNTERS_EXPLANATION_2: "Counters with increment will be highlighted in orange.",

  NO_DEVICES_WITH_MEDIA_COUNTERS_INCREMENT: "There are no devices on the network with media counters increment",

  // ------------------------------ INTERFACE COUNTERS ------------------------------
  ACTION_SUGGESTION: "Action suggestions",
  DEVICES_WITH_INTERFACE_COUNTERS_INCREMENT: "Devices with interface counters increment",
  INTERFACE_COUNTERS_LIST_HEADER: "There are devices with interface counters increment.",

  INTERFACE_COUNTERS_HEADER: "Interface Counters Increment",
  IN_DISCARDS_HEADER: "In Discards Increment",
  IN_ERRORS_HEADER: "In Errors Increment",
  IN_UNKNOWN_PROTOS_HEADER: "In Unknown Protos Increment",
  OUT_DISCARDS_HEADER: "Out Discards Increment",
  OUT_ERRORS_HEADER: "Out Errors Increment",
  INTERFACE_COUNTERS_NOT_SUPPORTED: "The device does not support access to interface counters",
  INTERFACE_COUNTERS_NOT_ANSWERED_YET: "The device has not responded yet",

  INTERFACE_COUNTERS_SUGGESTION_1: "When a device has Interface Counters increment, the following is suggested:",
  INTERFACE_COUNTERS_SUGGESTION_2: "Navigate to the Interface Counters tab and click the button in the upper-right corner of the screen (as shown in the image below) to download the action suggestions PDF.",
  INTERFACE_COUNTERS_SUGGESTION_3: "The document presents the possible causes for the increment of each Interface Counter type.",

  INTERFACE_COUNTERS_SUGGESTION_4: "Click the button below to download the action suggestions PDF. The document presents the possible causes for the increment of each Interface Counter type.",

  DEVS_WITH_INTERFACE_COUNTERS_EXPLANATION_1: "This list shows only the devices and respective ports that have increment in at least one type of interface counter.",
  DEVS_WITH_INTERFACE_COUNTERS_EXPLANATION_2: "Counters with increment will be highlighted in orange.",

  NO_DEVICES_WITH_INTERFACE_COUNTERS_INCREMENT: "There are no devices on the network with interface counters increment",

  // ---------------------------- FAULTS ----------------------------
  FAULTS_LIST_HEADER: "There are devices in fault on the network.",
  FAULTS_LIST_DESCR: "Please check your network.",
  DEVICE_WITH_FAULT: "Device in fault",

  FAULT_SUGGESTION_1: "When a device is in fault, the following is suggested:",
  FAULT_SUGGESTION_2: "Check the device power supply;",
  FAULT_SUGGESTION_3: "Check whether it is physically connected to the network;",
  FAULT_SUGGESTION_4: "Check cable integrity;",
  FAULT_SUGGESTION_5: "Check whether the device lost its IP address.",

  NO_DEVICE_WITH_FAULT: "There are no devices on the network with faults",

  // ---------------------------- LOST IP ----------------------------
  LOST_IP_LIST_HEADER: "There are devices with possible IP loss on the network.",
  LOST_IP_DESCR: "Please check your network.",
  DEVICE_WITH_LOST_IP: "Device with possible IP loss",

  LOST_IP_SUGGESTION_1: "When a device shows possible IP loss, the following is suggested:",
  LOST_IP_SUGGESTION_2: "Check the physical MAC addresses to identify the devices with the IP address conflict and correct the address settings.",

  // ---------------------------- EXPERT REPORT ----------------------------
  DUPLICATE_IP_PAGE_TITLE: ". - Duplicate IP",
  AVG_PING_EXCEEDED_PAGE_TITLE: ". - Ping limit exceeded",
  DHCP_CONFIG_METHOD_PAGE_TITLE: ". - DHCP configuration method",
  PACKET_LOSS_GREATER_ONE_PERCENT_PAGE_TITLE: ". - % of lost pings above the limit rate",
  INACTIVE_PORT_PAGE_TITLE: ". - Inactive port",
  AUTONEGOTIATION_FAILED_PAGE_TITLE: ". - Auto-negotiation failed",
  PORT_NOT_IN_FULL_DUPLEX_PAGE_TITLE: ". - Port not configured in Full Duplex mode",
  INTERFACE_SPEED_LESSER_THAN_100_PAGE_TITLE: ". - Interface speed < 100 Mbps",
  PORT_WITH_LOCAL_HARDWARE_FAULT_PAGE_TITLE: ". - Port with local hardware fault",
  ADDR_CONFLICT_DETECTED_PAGE_TITLE: ". - Address conflict detected",
  TS_EXPERT_MEDIA_COUNTERS_PAGE_TITLE: ". - Media Counters",
  TS_EXPERT_INTERFACE_COUNTERS_PAGE_TITLE: ". - Interface Counters",
  FAULT_PAGE_TITLE: ". - Device in fault",
  LOST_IP_PAGE_TITLE: ". - Device with possible IP loss",

  DUPLICATE_IP_DOTS: "...................................................................................................................................",
  AVG_PING_EXCEEDED_DOTS: ".......................................................................................................................",
  DHCP_CONFIG_METHOD_DOTS: ".........................................................................................................",
  PACKET_LOSS_GREATER_ONE_PERCENT_DOTS: "..............................................................................................",
  INACTIVE_PORT_DOTS: "...................................................................................................................................",
  AUTONEGOTIATION_FAILED_DOTS: "..................................................................................................................",
  PORT_NOT_IN_FULL_DUPLEX_DOTS: "......................................................................................",
  INTERFACE_SPEED_LESSER_THAN_100_DOTS: ".........................................................................................................",
  PORT_WITH_LOCAL_HARDWARE_FAULT_DOTS: ".......................................................................................................",
  ADDR_CONFLICT_DETECTED_DOTS: "...........................................................................................................",
  TS_EXPERT_DISCLAIMER_DOTS: ".....................................................................................................................................",
  DEVICE_WITH_FAULT_DOTS: "...............................................................................................................................",
  DEVICE_WITH_LOST_IP_DOTS: "........................................................................................................ ",

  AVG_PING_EXCEEDED: "Ping limit exceeded",
  REGISTERED_PING: "Recorded ping",

  // ---------------------------- LOG ----------------------------
  HORARY: "Time",
  EVENT: "Event",
  INSERT_VALID_LOG_INPUT: "Please enter a valid IP, MAC address, product name, or event type",

  // ---------------------------- TS EXPERT CONFIG ----------------------------
  SAVE: "Save",
  SENDING_TS_EXPERT_CONFIG_WAITING: "Updating TS Expert settings, please wait a moment.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "TS Expert settings were saved successfully.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "An error occurred while saving TS Expert settings.",

  TS_EXPERT_CONFIGURATION: "TS Expert Settings",

  CONFIG_DUPLICATE_IP_LIST_CONTENT: "When this option is enabled, TS Expert will record every time a duplicate IP is detected on the network.",

  CONFIG_EXCEEDED_PING_LIST_HEADER: "Exceeded ping time",
  CONFIG_EXCEEDED_PING_LIST_CONTENT: "When this option is enabled, TS Expert will record every time a device's average ping exceeds the ping limit value.",

  CONFIG_DHCP_LIST_HEADER: "DHCP",
  CONFIG_DHCP_LIST_CONTENT: "When this option is enabled, TS Expert will record every time a device's configuration method is DHCP.",

  CONFIG_LOST_PINGS_LIST_HEADER: "Lost pings",
  CONFIG_LOST_PINGS_LIST_CONTENT: "When this option is enabled, TS Expert will record every time a device's % of lost pings is greater than the limit rate.",

  CONFIG_INACTIVE_PORT_LIST_HEADER: "Inactive port",
  CONFIG_INACTIVE_PORT_LIST_CONTENT: "When this option is enabled, TS Expert will record every time an active device port becomes inactive.",

  CONFIG_AUTO_NEGOTIATION_LIST_HEADER: "Port with auto-negotiation problem",
  CONFIG_AUTO_NEGOTIATION_LIST_CONTENT: "When this option is enabled, TS Expert will record every time a problem occurs in a port's auto-negotiation",

  CONFIG_DUPLEX_LIST_HEADER: "Port not configured in Full Duplex mode",
  CONFIG_DUPLEX_LIST_CONTENT: "When this option is enabled, TS Expert will record every time a port duplex mode is not Full Duplex.",

  CONFIG_SLOW_SPEED_LIST_HEADER: "Port with interface speed < 100 Mbps",
  CONFIG_SLOW_SPEED_LIST_CONTENT: "When this option is enabled, TS Expert will record every time a port interface speed is < 100 Mbps.",

  CONFIG_LOCAL_HARDWARE_FAULT_LIST_HEADER: "Port with local hardware fault",
  CONFIG_LOCAL_HARDWARE_FAULT_LIST_CONTENT: "When this option is enabled, TS Expert will record every time a port has a local hardware fault.",

  CONFIG_ACD_LIST_HEADER: "ACD - Address conflict",
  CONFIG_ACD_LIST_CONTENT: "When this option is enabled, TS Expert will record every time a device detects that an address conflict occurred.",

  CONFIG_MEDIA_COUNTERS_LIST_HEADER: "Media Counters",
  CONFIG_MEDIA_COUNTERS_LIST_CONTENT: "When this option is enabled, TS Expert will record every time a device has an increment in the error of any counter on the Media Counters screen.",

  CONFIG_INTERFACE_COUNTERS_LIST_HEADER: "Interface Counters",
  CONFIG_INTERFACE_COUNTERS_LIST_CONTENT: "When this option is enabled, TS Expert will record every time a device has an increment in the error of any counter on the Interface Counters screen.",

  CONFIG_FAULTS_LIST_HEADER: "Faults",
  CONFIG_FAULTS_LIST_CONTENT: "If enabled, TS Expert will record every time an EtherNet/IP device enters fault status. This indicates that it is not responding to ping and arp commands on the network, that is, it is not accessible through the network.",

  CONFIG_LOST_IP_LIST_HEADER: "IP address loss",
  CONFIG_LOST_IP_LIST_CONTENT: "If enabled, TS Expert will record every time a device with possible IP address loss (0.0.0.0) is detected.",

  // ---------------------------- GRAPHIC TOPOLOGY ----------------------------
  EDIT_TOPOLOGY_POS_STRING: "Edit",
  SAVE_TOPOLOGY_POS_STRING: "Save",
  DELETE_TOPOLOGY_POS_STRING: "Remove",
  EXPORT_SVG: "SVG",

  EXPORT_TOPOLOGY: "Topology",
  IMPORT: "Import",
  IMPORT_TOPOLOGY: "Import Topology",
  POSITION: "Position",
  EXPORT: "Export",

  SAVE_TOPOLOGY_POS_SUCCESS_STRING: "Topology positioning was saved successfully!",
  SAVE_TOPOLOGY_POS_FAILURE_STRING: "The following error occurred while saving topology positioning: ",

  DROP_TOPOLOGY_POS_SUCCESS_STRING: "Topology positioning was removed successfully!",
  DROP_TOPOLOGY_POS_FAILURE_STRING: "The following error occurred while removing topology positioning: ",

  ASK_REMOVE_POSITIONING: "Are you sure you want to remove the saved positioning?",
  REMOVE_POSITIONING: "Remove positioning",

  YES: "Yes",
  NO: "No",

  ALERT_NOT_POSSIBLE_TO_EDIT: "Master data cannot be edited",
  ALERT_NOT_POSSIBLE_TO_EDIT_SCOPE: "TS Scope data cannot be edited",
  ALERT_NOT_POSSIBLE_TO_DELETE: "A device cannot be removed from the Live List",
  ALERT_CHOOSE_DEVICE_TYPE: "Please choose a device type",
  ALERT_CHOOSE_DEVICE_TYPE_ERROR: "Only EtherNet/IP devices can be edited",
  ALERT_CHOOSE_CONNECTION_TYPE: "Please select a connection type",

  ADD_DEVICE: "Add device",
  TAG_PLACEHOLDER: "TAG (optional)",

  DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER: "Choose a device type",
  ADD_CONNECTION: "Add connection",
  CONNECTION_DEFAULT_DROPDOWN_PLACEHOLDER: "Choose a connection type",
  EDIT_DEVICE: "Edit device",

  CANCEL: "Cancel",
  ADD: "Add",

  SCANNER_NAME: "Scanner",
  DEVICE_NAME_LABEL: "Name: ",
  DEVICE_NAME: "Device name",
  ACCESS_POINT_NAME: "Access Point",

  LOCALE_EDIT: "Edit",
  LOCALE_DEL: "Remove selected",
  LOCALE_BACK: "Back",
  LOCALE_ADD_NODE: "Add device",
  LOCALE_ADD_EDGE: "Add connection",
  LOCALE_EDIT_NODE: "Edit device",
  LOCALE_EDIT_EDGE: "Edit connection",
  LOCALE_ADD_DESCRIPTION: "Click an empty space to add a new device",
  LOCALE_EDGE_DESCRIPTION: "Click a device and drag the connection to another device to connect them",
  LOCALE_EDIT_EDGE_DESCRIPTION: "Click the control points and drag them to a device to connect them",
  LOCALE_CREATE_EDGE_ERROR: "A connection cannot be created for a cluster",
  LOCALE_DELETE_CLUSTER_ERROR: "Clusters cannot be removed",
  LOCALE_EDIT_CLUSTER_ERROR: "Clusters cannot be edited",

  FORM_NO_DEVICE_FOUND_PREFIX: "The device with address ",
  FORM_NO_DEVICE_FOUND_SUFFIX: " was not found",

  INSERT_VALID_ADDRESS_OR_TAG: "Please enter a valid address or tag",
  INSERT_VALID_ADDRESS0_TAG_OR_MODEL: "Please enter a valid address, tag, or model",

  POSITIONING_CONFLICT_1: "There is a conflict in the information for devices with the following addresses:",
  POSITIONING_CONFLICT_2: "\nTherefore, their positions and connections will return to the default state.",
  POSITIONING_ANG_CONNECTIONS_RESET_SUCCESS: "Positions and connections were reset to the default state successfully",
  POSITIONING_ANG_CONNECTIONS_RESET_FAILURE: "The following error occurred while resetting positions and connections to the default state: ",

  TOPOLOGY_IMPORT_SUCCESS: "The topology was imported successfully!",
  ERROR_IMPORTING_GRAPHIC_TOPOLOGY: "An error occurred while importing the graphic topology: ",
  INVALID_OR_CORRUPT_FILE: "The file is invalid or corrupted.",
  PLEASE_SELECT_TOPOLOGY_FILE: "Please select a topology file.",

  COLORS_LABELS: "Color and icon legend",
  LABEL_DEVICE_OK: ": EtherNet/IP device with OK communication status;",
  LABEL_DEVICE_INCREMENT_ERROR: ": EtherNet/IP device with error increments. See the Interface Counters screen.",
  LABEL_DEVICE_FAULT: ": EtherNet/IP device with communication failure;",
  LABEL_NO_STATUS: ": Device without status;",
  LABEL_DEVICE_ONLINE: ": Online device;",
  ADDRESS: "Address",
  MASTER_FAULT_STRING: "Scanner",
  DRIVE: "Drive",
  SWITCH: "Switch",

  INVALID_INSERTED_IP: "The entered IP is invalid",

  FORM_INPUT_NOT_FOUND_1: "The device with IP: ",
  FORM_INPUT_NOT_FOUND_2: " was not found",
  FORM_INPUT_INVALID_IP: "Enter a valid IP address",






  DUPLICATE_IPS: "The graphic topology could not be loaded because the network contains duplicate IP addresses.",


  // ---------------------------- MEDIA COUNTERS + INTERFACE COUNTERS REPORT ----------------------------
  GENERATING_ACTIONS_LIST_WAITING: "Generating action list PDF, please wait.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF generated successfully. To save it, click save action list.",

  GENERATING_ACTIONS_SUGESTIONS_WAITING: "Generating action suggestions PDF, please wait.",
  GENERATING_ACTIONS_SUGGESTIONS_SUCCESS: "PDF generated successfully. To save it, click save suggested actions.",

  SUGGESTED_ACTIONS_HEADER_TEXT: "Suggested actions - Media / Interface Counters",

  COMMON_CAUSES: "Common causes: ",

  ALIGNMENT_ERRORS_DOTS: "..........................................................................................................",
  CARRIER_SENSE_ERRORS_DOTS: ".....................................................................................................",
  FCS_ERRORS_DOTS: ".....................................................................................................................",
  SINGLE_COLLISIONS_DOTS: "...........................................................................................................",
  MULTIPLE_COLLISIONS_DOTS: "........................................................................................................",
  LATE_COLLISIONS_DOTS: "..............................................................................................................",
  EXCESSIVE_COLLISIONS_DOTS: ".....................................................................................................",
  DEFERRED_TRANSMISSIONS_DOTS: "...............................................................................................",
  FRAME_TOO_LONG_DOTS: "............................................................................................................",
  MAC_TRANSMIT_ERRORS_DOTS: "..................................................................................................",
  MAC_RECEIVE_ERRORS_DOTS: "....................................................................................................",

  IN_DISCARDS_DOTS: "..................................................................................................................",
  IN_ERRORS_DOTS: ".......................................................................................................................",
  IN_UNKNOWN_PROTOS_DOTS: ".....................................................................................................",
  OUT_DISCARDS_DOTS: "...............................................................................................................",
  OUT_ERRORS_DOTS: "....................................................................................................................",
  DEVS_WITH_INTERFACE_COUNTERS_DOTS: ".......................................................................",
  INTEFACE_COUNTERS_DISCLAIMER_DOTS: "....................................................................................................................................",

  ALIGNMENT_ERRORS_PAGE_TITLE: "1. - Alignment Errors Increment",
  CARRIER_SENSE_ERRORS_PAGE_TITLE: "2. - Carrier Sense Errors Increment",
  FCS_ERRORS_PAGE_TITLE: "3. - FCS Errors Increment",
  SINGLE_COLLISIONS_PAGE_TITLE: "4. - Single Collisions Increment",
  MULTIPLE_COLLISIONS_PAGE_TITLE: "5. - Multiple Collisions Increment",
  LATE_COLLISIONS_PAGE_TITLE: "6. - Late Collisions Increment",
  EXCESSIVE_COLLISIONS_PAGE_TITLE: "7. - Excessive Collisions Increment",
  DEFERRED_TRANSMISSIONS_PAGE_TITLE: "8. - Deferred Transmissions Increment",
  FRAME_TOO_LONG_PAGE_TITLE: "9. - Frame Too Long Increment",
  MAC_TRANSMIT_ERRORS_PAGE_TITLE: "10. - MAC Transmit Errors Increment",
  MAC_RECEIVE_ERRORS_PAGE_TITLE: "11. - MAC Receive Errors Increment",
  IN_DISCARDS_PAGE_TITLE: "12. - In Discards Increment",
  IN_ERRORS_PAGE_TITLE: "13. - In Errors Increment",
  IN_UNKNOWN_PROTOS_PAGE_TITLE: "14. - In Unknown Protos Increment",
  OUT_DISCARDS_PAGE_TITLE: "15. - Out Discards Increment",
  OUT_ERRORS_PAGE_TITLE: "16. - Out Errors Increment",

  ALIGNMENT_ERRORS_SUGGESTION_1: "When a device has Alignment Errors increment, the following is suggested:",
  ALIGNMENT_ERRORS_DP: "Alignment Errors: ",
  ALIGNMENT_ERRORS_SUGGESTION_2: "These are received packets without an even number of octets and with CRC problems.",
  ALIGNMENT_ERRORS_SUGGESTION_3: "They are usually the result of Duplex incompatibility or physical media problems such as cabling, ports, or network interface board. When connecting cables for the first time, this type of error may occur.",

  CARRIER_SENSE_ERRORS_SUGGESTION_1: "When a device has Carrier Sense Errors increment, the following is suggested:",
  CARRIER_SENSE_DP: "Carrier Sense: ",
  CARRIER_SENSE_ERRORS_SUGGESTION_2: "The parameter increments every time the Ethernet network controller attempts to send a packet. The network interface “listens” to the physical medium and checks whether it is not in use before sending the packet.",
  CARRIER_SENSE_ERRORS_SUGGESTION_3: "These events occur in normal operation on links configured as Half Duplex. If the link is configured as Full Duplex, it indicates a problem in the cabling, internal network board, or the Ethernet port itself.",

  FCS_ERRORS_SUGGESTION_1: "When a device has FCS Errors increment, the following is suggested:",
  FCS_ERRORS_DP: "FCS Errors (incorrect CRC): ",
  FCS_ERRORS_SUGGESTION_2: "Indicates the number of times a correctly sized packet presented different results between the sent and received checksum.",
  FCS_ERRORS_SUGGESTION_3: "Usually indicates physical media problems such as interference, cabling issues, or network interfaces connecting the equipment. CRC errors may also be caused by collisions and Duplex incompatibility.",

  SINGLE_COLLISIONS_SUGGESTION_1: "When a device has Single Collisions increment, the following is suggested:",
  MULTIPLE_COLLISIONS_SUGGESTION_1: "When a device has Multiple Collisions increment, the following is suggested:",
  EXCESSIVE_COLLISIONS_SUGGESTION_1: "When a device has Excessive Collisions increment, the following is suggested:",

  SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_DP: "Single/Multiple/Excessive Collisions: ",
  SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_SUGGESTION_2: "indicates the number of times one/multiple/16 collision(s) occurred before a packet was correctly sent.",
  SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_SUGGESTION_3: "Collisions are normal on links configured as Half Duplex, but they should not occur in Full Duplex configuration. If this parameter increases significantly, it is necessary to check for high bandwidth usage (excessive traffic), cabling assembly problems, or Duplex incompatibility.",

  LATE_COLLISIONS_SUGGESTION_1: "When a device has Late Collisions increment, the following is suggested:",
  LATE_COLLISIONS_DP: "Late Collisions: ",
  LATE_COLLISIONS_SUGGESTION_2: "Indicates the number of times a collision occurred without the devices being able to detect it because of a timing difference.",
  LATE_COLLISIONS_SUGGESTION_3: "Cabling with electrical alterations and, more commonly, excessively long cabling causes Late Collisions. Faulty network cards may cause this parameter to increase, as may Duplex incompatibility.",

  DEFERRED_TRANSMISSIONS_SUGGESTION_1: "When a device has Deferred Transmissions increment, the following is suggested:",
  DEFERRED_TRANSMISSIONS_DP: "Deferred Transmissions: ",
  DEFERRED_TRANSMISSIONS_SUGGESTION_2: "Indicates the number of times a packet was sent with delay due to network traffic and did not present errors or collisions.",
  DEFERRED_TRANSMISSIONS_SUGGESTION_3: "Mainly caused by excessive traffic, requiring either traffic reduction on the port showing this error or network topology reorganization.",

  FRAME_TOO_LONG_SUGGESTION_1: "When a device has Frame Too Long increment, the following is suggested:",
  FRAME_TOO_LONG_DP: "Frame too long: ",
  FRAME_TOO_LONG_SUGGESTION_2: "Indicates the number of times an Ethernet packet exceeded the allowed size.",
  FRAME_TOO_LONG_SUGGESTION_3: "Excessive Ethernet packet size or excessive amount of information such as TAGs.",

  MAC_TRANSMIT_ERRORS_SUGGESTION_1: "When a device has Mac Transmit Error increment, the following is suggested:",
  MAC_TRANSMIT_ERROR_DP: "MAC Transmit Error: ",
  MAC_TRANSMIT_ERRORS_SUGGESTION_2: "Indicates the number of times a packet whose transmission through an interface presented an error in the MAC sublayer. They are counted only if the parameters late collisions, excessive collisions, or carrier sense are not counted for a given packet.",
  MAC_TRANSMIT_ERRORS_SUGGESTION_3: "Possible hardware problem in the network card.",

  MAC_RECEIVE_ERRORS_SUGGESTION_1: "When a device has Mac Receive Error increment, the following is suggested:",
  MAC_RECEIVE_ERROR_DP: "MAC Receive Error: ",
  MAC_RECEIVE_ERRORS_SUGGESTION_2: "Indicates the number of times a packet whose reception through an interface presented an error in the MAC sublayer. They are counted only if the parameters frame too long, alignment, or FCS Errors are not counted for a given packet.",
  MAC_RECEIVE_ERRORS_SUGGESTION_3: "Possible hardware problem in the network card.",

  IN_DISCARDS_SUGGESTION_1: "When a device has In Discards increment, the following is suggested:",
  IN_DISCARDS_SUGGESTION_2: "• Check bandwidth usage on the port where the discards are occurring;",
  IN_DISCARDS_SUGGESTION_3: "• Check whether there is high memory and CPU usage on gateways, switches, and other equipment. These packets are usually discarded to free internal buffer space on overloaded equipment;",
  IN_DISCARDS_SUGGESTION_4: "• Check flow control or ACL (Address Control List) settings;",
  IN_DISCARDS_SUGGESTION_5: "• Unknown protocols (in some cases) may be present on the network and not supported;",
  IN_DISCARDS_SUGGESTION_6: "• Check whether the port is blocked by topology changes through STP (Spanning Tree Protocol).",

  IN_ERRORS_SUGGESTION_1: "When a device has In Errors increment, the following is suggested:",
  IN_ERRORS_SUGGESTION_2: "• Check for a Duplex problem (a 100 Mbps Full Duplex port connected to a 10 Mbps Half Duplex port). Links must have the same configuration at both ends and preferably use auto-negotiation;",
  IN_ERRORS_SUGGESTION_3: "• Check whether the data cable routes in cable trays, conduits, and trays are close to power cabling, drives, and other high-consumption equipment whose cabling may generate interference. Network cables must be kept as far away as possible or routed through isolated and grounded conduits;",
  IN_ERRORS_SUGGESTION_4: "• Check Ethernet link quality. Poorly assembled connectors, low-quality cables, and low-quality connectors may generate losses;",
  IN_ERRORS_SUGGESTION_5: "• Using a certifier, verify whether the cables are intact and have the performance capability for the category (Cat5, Cat5e, Cat6, etc.).",

  IN_UNKNOWN_PROTOS_SUGGESTION_1: "When a device has In Unknown Protos increment, the following is suggested:",
  IN_UNKNOWN_PROTOS_DP: "In Unknown Protos: ",
  IN_UNKNOWN_PROTOS_SUGGESTION_2: "Indicates the number of packets with unknown protocol received by the equipment. Increment of this parameter indicates the presence of unknown protocol traffic on the network.",
  IN_UNKNOWN_PROTOS_SUGGESTION_3: "Look for unknown equipment and software on the network that may be sending this traffic.",

  OUT_DISCARDS_SUGGESTION_1: "When a device has Out Discards increment, the following is suggested:",
  OUT_DISCARDS_SUGGESTION_2: "Check whether there is high memory and CPU usage on gateways, switches, and other equipment. These packets are usually discarded to free internal buffer space on overloaded equipment.",

  OUT_ERRORS_SUGGESTION_1: "When a device has Out Errors increment, the following is suggested:",
  OUT_ERRORS_SUGGESTION_2: "• Check for a Duplex problem (a 100 Mbps Full Duplex port connected to a 10 Mbps Half Duplex port). Links must have the same configuration at both ends and preferably use auto-negotiation;",
  OUT_ERRORS_SUGGESTION_3: "• Check Ethernet link quality. Poorly assembled connectors, low-quality cables, and low-quality connectors may generate losses;",
  OUT_ERRORS_SUGGESTION_4: "• Check for possible problems in the equipment's network interface, requiring replacement if detected.",

  MODEL: "Model",
  SUGGESTED_ACTIONS_BUTTON: "Suggested actions (PDF)",
  DESSELECT_ALL: "Deselect all",
  SAVE_REPORT: "Save report",
  LESS_THAN_A_MINUTE: "< 1 minute",
  SUGGESTED_ACTIONS_FILENAME: "Suggested actions.pdf",
  FINISHING: "Finishing...",
  SAVE_SUGGESTED_ACTIONS: "Save suggested actions",
  TS_EXPERT_REPORT_FILENAME: "TS Expert action list - Ethernet_IP.pdf",
  SAVE_ACTIONS_LIST: "Save action list",
  UNRESOLVED_PROBLEM_DUPLICATE_IP: "The following devices could not be checked because they still have a duplicate IP address:\n",
  UNRESOLVED_PROBLEM_PING: "The following devices could not be checked because their average ping remains above the configured limit:\n",
  UNRESOLVED_PROBLEM_DHCP: "The following devices could not be checked because they are still configured through DHCP:\n",
  UNRESOLVED_PROBLEM_PACKET_LOSS: "The following devices could not be checked because their lost-ping percentage is still at or above the limit:\n",
  UNRESOLVED_PROBLEM_INACTIVE_PORT: "The following devices could not be checked because their ports remain inactive:\n",
  UNRESOLVED_PROBLEM_AUTONEGOTIATION: "The following devices could not be checked because their ports still report an auto-negotiation failure:\n",
  UNRESOLVED_PROBLEM_DUPLEX: "The following devices could not be checked because their ports are not configured for Full Duplex:\n",
  UNRESOLVED_PROBLEM_INTERFACE_SPEED: "The following devices could not be checked because their interface speed remains below 100 Mbps:\n",
  UNRESOLVED_PROBLEM_HARDWARE_FAULT: "The following devices could not be checked because their ports still have a local hardware fault:\n",
  UNRESOLVED_PROBLEM_ADDRESS_CONFLICT: "The following devices could not be checked because they still detect an address conflict:\n",
  UNRESOLVED_PROBLEM_RETRY: "The following devices could not be checked. Please try again:\n",
  UNRESOLVED_PROBLEM_FAULT: "The following devices could not be checked because they remain in a fault state:\n",
  UNRESOLVED_PROBLEM_LOST_IP: "The following devices could not be checked because they still show a possible IP loss:\n",
  UNRESOLVED_PROBLEM_GENERIC: "The following devices could not be checked:",
  TS_EXPERT_ERROR_DEVICE: "Device:\n",
  TS_EXPERT_ERROR_DUPLICATE_IP: "• Duplicate IP: ",
  TS_EXPERT_ERROR_IP: "• IP: ",
  TS_EXPERT_ERROR_MAC: "• MAC: ",
  TS_EXPERT_ERROR_AVERAGE_PING: "• Average ping: ",
  TS_EXPERT_ERROR_CONFIGURATION_METHOD: "• Configuration method: ",
  TS_EXPERT_ERROR_LOST_PINGS: "• Lost pings (%): ",
  TS_EXPERT_ERROR_PORT: "• Port: ",
  TS_EXPERT_ERROR_NEGOTIATION_STATUS: "• Negotiation status: ",
  TS_EXPERT_ERROR_DUPLEX_MODE: "• Duplex mode: ",
  TS_EXPERT_ERROR_INTERFACE_SPEED: "• Interface speed: ",
  TS_EXPERT_ERROR_LOCAL_HARDWARE_FAULT: "• Local hardware fault: ",
  TS_EXPERT_ERROR_ACD_STATUS: "• ACD status: ",
  INVENTORY_MENU: "Inventory",
  PORTS_MENU: "Ports",
  NETWORK_MENU: "Network",
  PING_GRAPH_MENU: "Ping Graph",
  GRAPHIC_TOPOLOGY_MENU: "Graphic topology",
  CONFIGURATIONS_MENU: "Settings",
  CHART_MONTHS: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  CHART_SHORT_MONTHS: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  CHART_DAYS: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  CHART_SHORT_DAYS: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  CHART_DOWNLOAD_SVG: "Download SVG",
  CHART_DOWNLOAD_PNG: "Download PNG",
  CHART_DOWNLOAD_CSV: "Download CSV",
  CHART_DOWNLOAD: "Download",
  CHART_SELECT: "Select",
  CHART_SELECT_ZOOM: "Select zoom",
  CHART_ZOOM_IN: "Zoom in",
  CHART_ZOOM_OUT: "Zoom out",
  CHART_PAN: "Pan",
  CHART_RESET_ZOOM: "Reset zoom",
  PING_MILLISECONDS: "Ping (ms)",
  BATCH_CHECK_SUCCESS: "All events were successfully checked.",
  REPORT_PAGE: "Page",
  REPORT_PDF_FILENAME: "EtherNet/IP TS Monitor Report.pdf",
  TS_EXPERT_REPORT_TITLE: "TS Expert:",
  TS_EXPERT_REPORT_ACTION_LIST: "Action list",
  SUGGESTED_ACTIONS_REPORT_TITLE: "Suggested actions:",
  SUGGESTED_ACTIONS_REPORT_SUBTITLE: "Media Counters and Interface Counters",
  RELATIVE_YEAR: "year",
  RELATIVE_MONTH: "month",
  RELATIVE_MONTHS: "months",
  RELATIVE_DAY: "day",
  RELATIVE_HOUR: "hour",
  RELATIVE_MINUTE: "minute",
  REPORT_LEGEND: "Legend",
  REPORT_DUPLICATE_IP_LEGEND: "A device's IP cell will have a purple background when its IP is duplicated.",
  REPORT_DHCP_LEGEND: "The Configuration method cell will have a dark blue background when the method is DHCP.",
});

export default Strings;
